import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2485 2485"
      id="vector">
      <g
        id="group"
        transform="translate(330 72)">
        <path
          id="path"
          d="M 680.5 0 L 705 0.5 L 680.5 1 L 680.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1103.5 0 L 1128 0.5 L 1103.5 1 L 1103.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 670.5 1 L 674 1.5 L 670.5 2 L 670.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 711.5 1 L 715 1.5 L 711.5 2 L 711.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1092.5 1 L 1097 1.5 L 1092.5 2 L 1092.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1134.5 1 L 1138 1.5 L 1134.5 2 L 1134.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 663.5 2 L 666 2.5 L 663.5 3 L 663.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 719.5 2 L 722 2.5 L 719.5 3 L 719.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 1085.5 2 L 1089 2.5 L 1085.5 3 L 1085.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1142.5 2 L 1145 2.5 L 1142.5 3 L 1142.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 657.5 3 L 660 3.5 L 657.5 4 L 657.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1080.5 3 L 1083 3.5 L 1080.5 4 L 1080.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 779.5 23 L 780.5 25 L 779.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1203.5 23 L 1204.5 25 L 1203.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 784.5 26 L 785.5 28 L 784.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1208.5 26 L 1209.5 28 L 1208.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 595.5 28 L 594.5 30 L 595.5 28 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1015.5 29 L 1014.5 31 L 1015.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 592.5 30 L 591.5 32 L 592.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 790.5 30 L 791.5 32 L 790.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 1012.5 31 L 1011.5 33 L 1012.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 589.5 32 L 588.5 34 L 589.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 793.5 32 L 794.5 34 L 793.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1217.5 32 L 1218.5 34 L 1217.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 1220.5 34 L 1221.5 36 L 1220.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 585.5 35 L 584.5 37 L 585.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 797.5 35 L 798.5 37 L 797.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1005.5 36 L 1004.5 38 L 1005.5 36 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 1224.5 37 L 1226.5 40 L 1224.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 581.5 38 L 579.5 41 L 581.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 801.5 38 L 803.5 41 L 801.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1001.5 39 L 999.5 42 L 1001.5 39 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1229.5 41 L 1231.5 44 L 1229.5 41 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 576.5 42 L 572.5 47 L 576.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 806.5 42 L 810.5 47 L 806.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 995.5 44 L 990.5 50 L 995.5 44 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1235.5 46 L 1249.5 61 L 1235.5 46 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 815.5 50 L 820.5 56 L 815.5 50 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 566.5 51 L 565.5 53 L 566.5 51 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 982.5 57 L 976.5 64 L 982.5 57 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 559.5 59 L 555.5 64 L 559.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 824.5 60 L 828.5 65 L 824.5 60 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1252.5 64 L 1255.5 68 L 1252.5 64 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 553.5 66 L 551.5 69 L 553.5 66 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 974.5 66 L 972.5 69 L 974.5 66 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 830.5 67 L 832.5 70 L 830.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1257.5 70 L 1258.5 72 L 1257.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 549.5 71 L 548.5 73 L 549.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 970.5 71 L 969.5 73 L 970.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 834.5 72 L 835.5 74 L 834.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 547.5 74 L 546.5 76 L 547.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 1260.5 74 L 1261.5 76 L 1260.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 967.5 75 L 966.5 77 L 967.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 837.5 76 L 838.5 78 L 837.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 965.5 78 L 964.5 80 L 965.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 1263.5 78 L 1264.5 80 L 1263.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 839.5 79 L 840.5 81 L 839.5 79 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 1265.5 81 L 1266.5 83 L 1265.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 841.5 82 L 842.5 84 L 841.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 541.5 83 L 540.5 85 L 541.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 961.5 84 L 960.5 86 L 961.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 843.5 85 L 844.5 87 L 843.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 538.5 88 L 537.5 90 L 538.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 958.5 89 L 957.5 91 L 958.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 1270.5 89 L 1271.5 91 L 1270.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 846.5 90 L 847.5 92 L 846.5 90 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 689.5 93 L 697 93.5 L 689.5 94 L 689.5 93 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1112.5 93 L 1118 93.5 L 1112.5 94 L 1112.5 93 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 679.5 94 L 683 94.5 L 679.5 95 L 679.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 703.5 94 L 707 94.5 L 703.5 95 L 703.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1101.5 94 L 1105 94.5 L 1101.5 95 L 1101.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1124.5 94 L 1128 94.5 L 1124.5 95 L 1124.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 709.5 95 L 712 95.5 L 709.5 96 L 709.5 95 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 648.5 105 L 647.5 107 L 648.5 105 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 736.5 105 L 737.5 107 L 736.5 105 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 1067.5 106 L 1066.5 108 L 1067.5 106 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1064.5 108 L 1063.5 110 L 1064.5 108 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 642.5 109 L 641.5 111 L 642.5 109 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 742.5 109 L 743.5 111 L 742.5 109 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 1061.5 110 L 1060.5 112 L 1061.5 110 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1166.5 111 L 1167.5 113 L 1166.5 111 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 638.5 112 L 636.5 115 L 638.5 112 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 746.5 112 L 758.5 125 L 746.5 112 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1057.5 113 L 1046.5 125 L 1057.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 1171.5 115 L 1181.5 126 L 1171.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 628.5 122 L 625.5 126 L 628.5 122 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 760.5 127 L 761.5 129 L 760.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1044.5 127 L 1043.5 129 L 1044.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 623.5 128 L 622.5 130 L 623.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 1183.5 128 L 1185.5 131 L 1183.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 762.5 130 L 763.5 132 L 762.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 764.5 133 L 765.5 135 L 764.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1040.5 133 L 1039.5 135 L 1040.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 519.5 136 L 520 138.5 L 519 138.5 L 519.5 136 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 518.5 141 L 519 143.5 L 518 143.5 L 518.5 141 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 1291.5 141 L 1292 143.5 L 1291 143.5 L 1291.5 141 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 867.5 144 L 868 146.5 L 867 146.5 L 867.5 144 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1292.5 146 L 1293 148.5 L 1292 148.5 L 1292.5 146 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 517.5 147 L 518 150.5 L 517 150.5 L 517.5 147 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 937.5 148 L 938 150.5 L 937 150.5 L 937.5 148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 868.5 150 L 869 152.5 L 868 152.5 L 868.5 150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1293.5 152 L 1294 154.5 L 1293 154.5 L 1293.5 152 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 516.5 155 L 517 159.5 L 516 159.5 L 516.5 155 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 936.5 155 L 937 160.5 L 936 160.5 L 936.5 155 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 869.5 157 L 870 161.5 L 869 161.5 L 869.5 157 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 1030.5 158 L 1031 160.5 L 1030 160.5 L 1030.5 158 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1294.5 160 L 1295 164.5 L 1294 164.5 L 1294.5 160 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 609.5 164 L 610 168.5 L 609 168.5 L 609.5 164 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1029.5 164 L 1030 169.5 L 1029 169.5 L 1029.5 164 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 776.5 165 L 777 168.5 L 776 168.5 L 776.5 165 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 870.5 168 L 871 182.5 L 870 182.5 L 870.5 168 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1201.5 169 L 1202 173.5 L 1201 173.5 L 1201.5 169 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 777.5 181 L 778 184.5 L 777 184.5 L 777.5 181 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1202.5 184 L 1203 186.5 L 1202 186.5 L 1202.5 184 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 1294.5 184 L 1295 186.5 L 1294 186.5 L 1294.5 184 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 869.5 186 L 870 188.5 L 869 188.5 L 869.5 186 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1289.5 200 L 1288.5 202 L 1289.5 200 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 783.5 201 L 784.5 203 L 783.5 201 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 863.5 202 L 862.5 204 L 863.5 202 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1209.5 203 L 1210.5 205 L 1209.5 203 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 785.5 204 L 786.5 206 L 785.5 204 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 861.5 205 L 859.5 208 L 861.5 205 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1285.5 206 L 1277.5 215 L 1285.5 206 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 1212.5 207 L 1219.5 215 L 1212.5 207 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 788.5 208 L 792.5 213 L 788.5 208 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 853.5 213 L 851.5 216 L 853.5 213 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 795.5 214 L 796.5 216 L 795.5 214 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1221.5 215 L 1222.5 217 L 1221.5 215 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 849.5 216 L 848.5 218 L 849.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 1224.5 217 L 1225.5 219 L 1224.5 217 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 801.5 218 L 802.5 220 L 801.5 218 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 831.5 223 L 834 223.5 L 831.5 224 L 831.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 1238.5 223 L 1241 223.5 L 1238.5 224 L 1238.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 1256.5 223 L 1259 223.5 L 1256.5 224 L 1256.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 821.5 224 L 827 224.5 L 821.5 225 L 821.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 1245.5 224 L 1252 224.5 L 1245.5 225 L 1245.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 609.5 254 L 936 254.5 L 609.5 255 L 609.5 254 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 356.5 441 L 516 441.5 L 356.5 442 L 356.5 441 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 1029.5 441 L 1468 441.5 L 1029.5 442 L 1029.5 441 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 345.5 442 L 350 442.5 L 345.5 443 L 345.5 442 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 1475.5 442 L 1480 442.5 L 1475.5 443 L 1475.5 442 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 338.5 443 L 342 443.5 L 338.5 444 L 338.5 443 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 1483.5 443 L 1487 443.5 L 1483.5 444 L 1483.5 443 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1490.5 444 L 1493 444.5 L 1490.5 445 L 1490.5 444 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1495.5 445 L 1498 445.5 L 1495.5 446 L 1495.5 445 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 609.5 464 L 936 464.5 L 609.5 465 L 609.5 464 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 260.5 473 L 259.5 475 L 260.5 473 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1566.5 474 L 1567.5 476 L 1566.5 474 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 257.5 475 L 256.5 477 L 257.5 475 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 1569.5 476 L 1570.5 478 L 1569.5 476 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 254.5 477 L 253.5 479 L 254.5 477 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1573.5 479 L 1574.5 481 L 1573.5 479 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 250.5 480 L 249.5 482 L 250.5 480 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 1576.5 481 L 1577.5 483 L 1576.5 481 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 246.5 483 L 245.5 485 L 246.5 483 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1580.5 484 L 1582.5 487 L 1580.5 484 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 242.5 486 L 240.5 489 L 242.5 486 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1585.5 488 L 1588.5 492 L 1585.5 488 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 236.5 491 L 231.5 497 L 236.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 1592.5 494 L 1609.5 512 L 1592.5 494 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 218.5 509 L 213.5 515 L 218.5 509 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 1612.5 515 L 1615.5 519 L 1612.5 515 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 211.5 517 L 208.5 521 L 211.5 517 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1617.5 521 L 1618.5 523 L 1617.5 521 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 206.5 523 L 205.5 525 L 206.5 523 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 1620.5 525 L 1621.5 527 L 1620.5 525 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 203.5 527 L 202.5 529 L 203.5 527 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1623.5 529 L 1624.5 531 L 1623.5 529 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 201.5 530 L 200.5 532 L 201.5 530 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 1625.5 532 L 1626.5 534 L 1625.5 532 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 367.5 534 L 496 534.5 L 367.5 535 L 367.5 534 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 354.5 535 L 359 535.5 L 354.5 536 L 354.5 535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 1466.5 535 L 1470 535.5 L 1466.5 536 L 1466.5 535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 348.5 536 L 351 536.5 L 348.5 537 L 348.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1629.5 538 L 1630.5 540 L 1629.5 538 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 1631.5 541 L 1632.5 543 L 1631.5 541 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 193.5 542 L 192.5 544 L 193.5 542 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 190.5 547 L 189.5 549 L 190.5 547 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 312.5 550 L 311.5 552 L 312.5 550 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 309.5 552 L 308.5 554 L 309.5 552 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 1513.5 552 L 1514.5 554 L 1513.5 552 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 306.5 554 L 305.5 556 L 306.5 554 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 302.5 557 L 301.5 559 L 302.5 557 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 1520.5 557 L 1522.5 560 L 1520.5 557 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 298.5 560 L 294.5 565 L 298.5 560 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 1525.5 561 L 1540.5 577 L 1525.5 561 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 287.5 571 L 283.5 576 L 287.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 281.5 578 L 279.5 581 L 281.5 578 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1542.5 579 L 1544.5 582 L 1542.5 579 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1545.5 583 L 1546.5 585 L 1545.5 583 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1551.5 592 L 1552.5 594 L 1551.5 592 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1658.5 607 L 1659 609.5 L 1658 609.5 L 1658.5 607 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1659.5 612 L 1660 614.5 L 1659 614.5 L 1659.5 612 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 164.5 617 L 165 619.5 L 164 619.5 L 164.5 617 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1660.5 618 L 1661 620.5 L 1660 620.5 L 1660.5 618 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 163.5 623 L 164 626.5 L 163 626.5 L 163.5 623 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 1661.5 625 L 1662 628.5 L 1661 628.5 L 1661.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 1566.5 628 L 1567 630.5 L 1566 630.5 L 1566.5 628 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 162.5 631 L 163 634.5 L 162 634.5 L 162.5 631 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 257.5 631 L 258 633.5 L 257 633.5 L 257.5 631 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1567.5 633 L 1568 635.5 L 1567 635.5 L 1567.5 633 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 1662.5 633 L 1663 636.5 L 1662 636.5 L 1662.5 633 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 256.5 638 L 257 641.5 L 256 641.5 L 256.5 638 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 161.5 639 L 162 643.5 L 161 643.5 L 161.5 639 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1568.5 640 L 1569 643.5 L 1568 643.5 L 1568.5 640 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 1663.5 642 L 1664 645.5 L 1663 645.5 L 1663.5 642 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 255.5 646 L 256 649.5 L 255 649.5 L 255.5 646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 160.5 648 L 161 651.5 L 160 651.5 L 160.5 648 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1569.5 648 L 1570 652.5 L 1569 652.5 L 1569.5 648 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1664.5 650 L 1665 653.5 L 1664 653.5 L 1664.5 650 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 254.5 654 L 255 658.5 L 254 658.5 L 254.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 159.5 656 L 160 659.5 L 159 659.5 L 159.5 656 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1570.5 657 L 1571 660.5 L 1570 660.5 L 1570.5 657 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1665.5 658 L 1666 662.5 L 1665 662.5 L 1665.5 658 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 253.5 663 L 254 666.5 L 253 666.5 L 253.5 663 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 158.5 664 L 159 667.5 L 158 667.5 L 158.5 664 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1571.5 665 L 1572 668.5 L 1571 668.5 L 1571.5 665 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 1666.5 667 L 1667 670.5 L 1666 670.5 L 1666.5 667 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 252.5 671 L 253 674.5 L 252 674.5 L 252.5 671 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 157.5 673 L 158 676.5 L 157 676.5 L 157.5 673 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1572.5 673 L 1573 676.5 L 1572 676.5 L 1572.5 673 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 1667.5 675 L 1668 678.5 L 1667 678.5 L 1667.5 675 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 251.5 679 L 252 683.5 L 251 683.5 L 251.5 679 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 156.5 681 L 157 684.5 L 156 684.5 L 156.5 681 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1573.5 682 L 1574 685.5 L 1573 685.5 L 1573.5 682 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1668.5 684 L 1669 687.5 L 1668 687.5 L 1668.5 684 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 509.5 686 L 516 686.5 L 509.5 687 L 509.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 499.5 687 L 503 687.5 L 499.5 688 L 499.5 687 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 250.5 688 L 251 691.5 L 250 691.5 L 250.5 688 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 493.5 688 L 496 688.5 L 493.5 689 L 493.5 688 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 155.5 689 L 156 692.5 L 155 692.5 L 155.5 689 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 1574.5 690 L 1575 693.5 L 1574 693.5 L 1574.5 690 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1669.5 692 L 1670 695.5 L 1669 695.5 L 1669.5 692 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 249.5 696 L 250 699.5 L 249 699.5 L 249.5 696 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 154.5 698 L 155 701.5 L 154 701.5 L 154.5 698 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1312.5 698 L 1320 698.5 L 1312.5 699 L 1312.5 698 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1575.5 698 L 1576 701.5 L 1575 701.5 L 1575.5 698 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 1325.5 699 L 1329 699.5 L 1325.5 700 L 1325.5 699 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 1332.5 700 L 1335 700.5 L 1332.5 701 L 1332.5 700 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1670.5 700 L 1671 704.5 L 1670 704.5 L 1670.5 700 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 248.5 704 L 249 707.5 L 248 707.5 L 248.5 704 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 153.5 706 L 154 709.5 L 153 709.5 L 153.5 706 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 442.5 706 L 441.5 708 L 442.5 706 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 1576.5 706 L 1577 710.5 L 1576 710.5 L 1576.5 706 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 437.5 709 L 436.5 711 L 437.5 709 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 1671.5 709 L 1672 712.5 L 1671 712.5 L 1671.5 709 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 247.5 713 L 248 716.5 L 247 716.5 L 247.5 713 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 431.5 713 L 430.5 715 L 431.5 713 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 152.5 714 L 153 717.5 L 152 717.5 L 152.5 714 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 428.5 715 L 427.5 717 L 428.5 715 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1577.5 715 L 1578 718.5 L 1577 718.5 L 1577.5 715 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 1382.5 716 L 1383.5 718 L 1382.5 716 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1672.5 717 L 1673 720.5 L 1672 720.5 L 1672.5 717 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 424.5 718 L 423.5 720 L 424.5 718 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 246.5 721 L 247 724.5 L 246 724.5 L 246.5 721 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 420.5 721 L 417.5 725 L 420.5 721 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 151.5 723 L 152 726.5 L 151 726.5 L 151.5 723 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1394.5 723 L 1395.5 725 L 1394.5 723 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 1578.5 723 L 1579 726.5 L 1578 726.5 L 1578.5 723 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 1397.5 725 L 1398.5 727 L 1397.5 725 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 414.5 726 L 401.5 740 L 414.5 726 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1673.5 726 L 1674 729.5 L 1673 729.5 L 1673.5 726 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1400.5 727 L 1401.5 729 L 1400.5 727 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 245.5 729 L 246 732.5 L 245 732.5 L 245.5 729 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1404.5 730 L 1405.5 732 L 1404.5 730 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 150.5 731 L 151 734.5 L 150 734.5 L 150.5 731 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1579.5 731 L 1580 734.5 L 1579 734.5 L 1579.5 731 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 1408.5 733 L 1410.5 736 L 1408.5 733 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1674.5 734 L 1675 737.5 L 1674 737.5 L 1674.5 734 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 244.5 738 L 245 741.5 L 244 741.5 L 244.5 738 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1414.5 738 L 1427.5 752 L 1414.5 738 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 149.5 739 L 150 742.5 L 149 742.5 L 149.5 739 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1580.5 740 L 1581 743.5 L 1580 743.5 L 1580.5 740 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 399.5 742 L 396.5 746 L 399.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1675.5 742 L 1676 746.5 L 1675 746.5 L 1675.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 243.5 746 L 244 749.5 L 243 749.5 L 243.5 746 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 148.5 748 L 149 751.5 L 148 751.5 L 148.5 748 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 394.5 748 L 393.5 750 L 394.5 748 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1581.5 748 L 1582 751.5 L 1581 751.5 L 1581.5 748 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 1676.5 751 L 1677 754.5 L 1676 754.5 L 1676.5 751 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 391.5 752 L 390.5 754 L 391.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 242.5 754 L 243 757.5 L 242 757.5 L 242.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 1429.5 754 L 1432.5 758 L 1429.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 389.5 755 L 388.5 757 L 389.5 755 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 147.5 756 L 148 759.5 L 147 759.5 L 147.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1582.5 756 L 1583 759.5 L 1582 759.5 L 1582.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1433.5 759 L 1435.5 762 L 1433.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1677.5 759 L 1678 762.5 L 1677 762.5 L 1677.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 385.5 761 L 384.5 763 L 385.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 241.5 763 L 242 766.5 L 241 766.5 L 241.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 1436.5 763 L 1437.5 765 L 1436.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 146.5 764 L 147 767.5 L 146 767.5 L 146.5 764 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1583.5 764 L 1584 768.5 L 1583 768.5 L 1583.5 764 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 382.5 766 L 381.5 768 L 382.5 766 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1678.5 768 L 1679 771.5 L 1678 771.5 L 1678.5 768 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 240.5 771 L 241 774.5 L 240 774.5 L 240.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 145.5 772 L 146 776.5 L 145 776.5 L 145.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 1442.5 772 L 1443.5 774 L 1442.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1584.5 773 L 1585 776.5 L 1584 776.5 L 1584.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 1679.5 776 L 1680 779.5 L 1679 779.5 L 1679.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 239.5 779 L 240 782.5 L 239 782.5 L 239.5 779 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 509.5 780 L 512 780.5 L 509.5 781 L 509.5 780 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 144.5 781 L 145 784.5 L 144 784.5 L 144.5 781 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 1585.5 781 L 1586 784.5 L 1585 784.5 L 1585.5 781 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 1680.5 784 L 1681 788.5 L 1680 788.5 L 1680.5 784 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 238.5 788 L 239 791.5 L 238 791.5 L 238.5 788 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 143.5 789 L 144 792.5 L 143 792.5 L 143.5 789 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 1586.5 789 L 1587 792.5 L 1586 792.5 L 1586.5 789 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 484.5 790 L 483.5 792 L 484.5 790 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 609.5 791 L 936 791.5 L 609.5 792 L 609.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 1029.5 791 L 1312 791.5 L 1029.5 792 L 1029.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 1316.5 792 L 1319 792.5 L 1316.5 793 L 1316.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 480.5 793 L 478.5 796 L 480.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 1681.5 793 L 1682 796.5 L 1681 796.5 L 1681.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 237.5 796 L 238 799.5 L 237 799.5 L 237.5 796 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 142.5 797 L 143 801.5 L 142 801.5 L 142.5 797 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1587.5 798 L 1588 801.5 L 1587 801.5 L 1587.5 798 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 1682.5 801 L 1683 804.5 L 1682 804.5 L 1682.5 801 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 471.5 802 L 468.5 806 L 471.5 802 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 1346.5 803 L 1347.5 805 L 1346.5 803 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 236.5 804 L 237 807.5 L 236 807.5 L 236.5 804 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 141.5 806 L 142 809.5 L 141 809.5 L 141.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 1350.5 806 L 1359.5 816 L 1350.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 1588.5 806 L 1589 809.5 L 1588 809.5 L 1588.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 467.5 807 L 466.5 809 L 467.5 807 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 465.5 810 L 464.5 812 L 465.5 810 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 1683.5 810 L 1684 813.5 L 1683 813.5 L 1683.5 810 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 235.5 812 L 236 816.5 L 235 816.5 L 235.5 812 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 140.5 814 L 141 817.5 L 140 817.5 L 140.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 1589.5 814 L 1590 817.5 L 1589 817.5 L 1589.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 363.5 816 L 364 818.5 L 363 818.5 L 363.5 816 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 1361.5 818 L 1362.5 820 L 1361.5 818 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1684.5 818 L 1685 821.5 L 1684 821.5 L 1684.5 818 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1461.5 820 L 1462 822.5 L 1461 822.5 L 1461.5 820 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 234.5 821 L 235 824.5 L 234 824.5 L 234.5 821 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 139.5 822 L 140 826.5 L 139 826.5 L 139.5 822 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 362.5 822 L 363 824.5 L 362 824.5 L 362.5 822 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 1590.5 822 L 1591 826.5 L 1590 826.5 L 1590.5 822 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 1462.5 826 L 1463 828.5 L 1462 828.5 L 1462.5 826 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 1685.5 826 L 1686 830.5 L 1685 830.5 L 1685.5 826 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 233.5 829 L 234 832.5 L 233 832.5 L 233.5 829 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 361.5 829 L 362 832.5 L 361 832.5 L 361.5 829 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 138.5 831 L 139 834.5 L 138 834.5 L 138.5 831 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 1591.5 831 L 1592 834.5 L 1591 834.5 L 1591.5 831 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 1463.5 833 L 1464 836.5 L 1463 836.5 L 1463.5 833 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1686.5 835 L 1687 838.5 L 1686 838.5 L 1686.5 835 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 232.5 837 L 233 841.5 L 232 841.5 L 232.5 837 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 360.5 837 L 361 840.5 L 360 840.5 L 360.5 837 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 137.5 839 L 138 842.5 L 137 842.5 L 137.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 1592.5 839 L 1593 842.5 L 1592 842.5 L 1592.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 1371.5 840 L 1372 842.5 L 1371 842.5 L 1371.5 840 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 454.5 841 L 455 844.5 L 454 844.5 L 454.5 841 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 1464.5 841 L 1465 845.5 L 1464 845.5 L 1464.5 841 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1687.5 843 L 1688 846.5 L 1687 846.5 L 1687.5 843 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 359.5 845 L 360 848.5 L 359 848.5 L 359.5 845 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 231.5 846 L 232 849.5 L 231 849.5 L 231.5 846 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 1372.5 846 L 1373 849.5 L 1372 849.5 L 1372.5 846 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 136.5 847 L 137 851.5 L 136 851.5 L 136.5 847 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1593.5 847 L 1594 850.5 L 1593 850.5 L 1593.5 847 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 453.5 849 L 454 853.5 L 453 853.5 L 453.5 849 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 1465.5 850 L 1466 853.5 L 1465 853.5 L 1465.5 850 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 1688.5 852 L 1689 855.5 L 1688 855.5 L 1688.5 852 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 358.5 853 L 359 856.5 L 358 856.5 L 358.5 853 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 230.5 854 L 231 857.5 L 230 857.5 L 230.5 854 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 1373.5 854 L 1374 857.5 L 1373 857.5 L 1373.5 854 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 135.5 856 L 136 859.5 L 135 859.5 L 135.5 856 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 1594.5 856 L 1595 859.5 L 1594 859.5 L 1594.5 856 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 452.5 858 L 453 861.5 L 452 861.5 L 452.5 858 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 1466.5 858 L 1467 861.5 L 1466 861.5 L 1466.5 858 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 1689.5 860 L 1690 863.5 L 1689 863.5 L 1689.5 860 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 229.5 862 L 230 866.5 L 229 866.5 L 229.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 357.5 862 L 358 865.5 L 357 865.5 L 357.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1374.5 862 L 1375 865.5 L 1374 865.5 L 1374.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 134.5 864 L 135 867.5 L 134 867.5 L 134.5 864 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1595.5 864 L 1596 867.5 L 1595 867.5 L 1595.5 864 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 451.5 866 L 452 869.5 L 451 869.5 L 451.5 866 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 1467.5 866 L 1468 869.5 L 1467 869.5 L 1467.5 866 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 1690.5 868 L 1691 872.5 L 1690 872.5 L 1690.5 868 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 356.5 870 L 357 873.5 L 356 873.5 L 356.5 870 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 1375.5 870 L 1376 873.5 L 1375 873.5 L 1375.5 870 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 228.5 871 L 229 874.5 L 228 874.5 L 228.5 871 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 133.5 872 L 134 875.5 L 133 875.5 L 133.5 872 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 1596.5 872 L 1597 875.5 L 1596 875.5 L 1596.5 872 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 450.5 874 L 451 877.5 L 450 877.5 L 450.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 1468.5 874 L 1469 877.5 L 1468 877.5 L 1468.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 1691.5 877 L 1692 880.5 L 1691 880.5 L 1691.5 877 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 355.5 878 L 356 881.5 L 355 881.5 L 355.5 878 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 227.5 879 L 228 882.5 L 227 882.5 L 227.5 879 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 1376.5 879 L 1377 882.5 L 1376 882.5 L 1376.5 879 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 132.5 881 L 133 884.5 L 132 884.5 L 132.5 881 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1597.5 881 L 1598 884.5 L 1597 884.5 L 1597.5 881 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 449.5 882 L 450 885.5 L 449 885.5 L 449.5 882 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 1469.5 882 L 1470 885.5 L 1469 885.5 L 1469.5 882 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 1692.5 885 L 1693 888.5 L 1692 888.5 L 1692.5 885 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 354.5 886 L 355 889.5 L 354 889.5 L 354.5 886 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 226.5 887 L 227 890.5 L 226 890.5 L 226.5 887 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 1377.5 887 L 1378 890.5 L 1377 890.5 L 1377.5 887 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 131.5 889 L 132 892.5 L 131 892.5 L 131.5 889 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 1598.5 889 L 1599 892.5 L 1598 892.5 L 1598.5 889 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 448.5 890 L 449 894.5 L 448 894.5 L 448.5 890 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 1470.5 890 L 1471 894.5 L 1470 894.5 L 1470.5 890 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 353.5 894 L 354 898.5 L 353 898.5 L 353.5 894 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1693.5 894 L 1694 897.5 L 1693 897.5 L 1693.5 894 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 1378.5 895 L 1379 898.5 L 1378 898.5 L 1378.5 895 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 225.5 896 L 226 899.5 L 225 899.5 L 225.5 896 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 130.5 897 L 131 900.5 L 130 900.5 L 130.5 897 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 1599.5 897 L 1600 900.5 L 1599 900.5 L 1599.5 897 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 447.5 899 L 448 902.5 L 447 902.5 L 447.5 899 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 1471.5 899 L 1472 902.5 L 1471 902.5 L 1471.5 899 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 1694.5 902 L 1695 905.5 L 1694 905.5 L 1694.5 902 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 352.5 903 L 353 906.5 L 352 906.5 L 352.5 903 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 1379.5 903 L 1380 906.5 L 1379 906.5 L 1379.5 903 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 224.5 904 L 225 907.5 L 224 907.5 L 224.5 904 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 1600.5 905 L 1601 909.5 L 1600 909.5 L 1600.5 905 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 129.5 906 L 130 909.5 L 129 909.5 L 129.5 906 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 446.5 907 L 447 910.5 L 446 910.5 L 446.5 907 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 1472.5 907 L 1473 910.5 L 1472 910.5 L 1472.5 907 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 1695.5 910 L 1696 914.5 L 1695 914.5 L 1695.5 910 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 351.5 911 L 352 914.5 L 351 914.5 L 351.5 911 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1380.5 911 L 1381 914.5 L 1380 914.5 L 1380.5 911 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 223.5 912 L 224 915.5 L 223 915.5 L 223.5 912 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 128.5 914 L 129 917.5 L 128 917.5 L 128.5 914 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 1601.5 914 L 1602 917.5 L 1601 917.5 L 1601.5 914 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 445.5 915 L 446 918.5 L 445 918.5 L 445.5 915 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 1473.5 915 L 1474 918.5 L 1473 918.5 L 1473.5 915 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 350.5 919 L 351 922.5 L 350 922.5 L 350.5 919 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1696.5 919 L 1697 922.5 L 1696 922.5 L 1696.5 919 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 1381.5 920 L 1382 923.5 L 1381 923.5 L 1381.5 920 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 222.5 921 L 223 924.5 L 222 924.5 L 222.5 921 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 127.5 922 L 128 925.5 L 127 925.5 L 127.5 922 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1602.5 922 L 1603 925.5 L 1602 925.5 L 1602.5 922 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 444.5 923 L 445 926.5 L 444 926.5 L 444.5 923 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1474.5 923 L 1475 926.5 L 1474 926.5 L 1474.5 923 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 349.5 927 L 350 930.5 L 349 930.5 L 349.5 927 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 1697.5 927 L 1698 930.5 L 1697 930.5 L 1697.5 927 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 1382.5 928 L 1383 931.5 L 1382 931.5 L 1382.5 928 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 221.5 929 L 222 932.5 L 221 932.5 L 221.5 929 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1603.5 930 L 1604 933.5 L 1603 933.5 L 1603.5 930 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 126.5 931 L 127 934.5 L 126 934.5 L 126.5 931 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 443.5 931 L 444 935.5 L 443 935.5 L 443.5 931 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 1475.5 931 L 1476 934.5 L 1475 934.5 L 1475.5 931 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 348.5 936 L 349 939.5 L 348 939.5 L 348.5 936 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 1383.5 936 L 1384 939.5 L 1383 939.5 L 1383.5 936 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 1698.5 936 L 1699 939.5 L 1698 939.5 L 1698.5 936 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 220.5 937 L 221 940.5 L 220 940.5 L 220.5 937 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 516.5 938 L 517 940.5 L 516 940.5 L 516.5 938 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 608.5 938 L 609 940.5 L 608 940.5 L 608.5 938 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 936.5 938 L 937 940.5 L 936 940.5 L 936.5 938 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1028.5 938 L 1029 940.5 L 1028 940.5 L 1028.5 938 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 125.5 939 L 126 942.5 L 125 942.5 L 125.5 939 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 1476.5 939 L 1477 942.5 L 1476 942.5 L 1476.5 939 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 1604.5 939 L 1605 942.5 L 1604 942.5 L 1604.5 939 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 442.5 940 L 443 943.5 L 442 943.5 L 442.5 940 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 347.5 944 L 348 947.5 L 347 947.5 L 347.5 944 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1384.5 944 L 1385 947.5 L 1384 947.5 L 1384.5 944 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1699.5 944 L 1700 947.5 L 1699 947.5 L 1699.5 944 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 219.5 946 L 220 949.5 L 219 949.5 L 219.5 946 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 124.5 947 L 125 950.5 L 124 950.5 L 124.5 947 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1605.5 947 L 1606 950.5 L 1605 950.5 L 1605.5 947 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 441.5 948 L 442 951.5 L 441 951.5 L 441.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 1477.5 948 L 1478 951.5 L 1477 951.5 L 1477.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 346.5 952 L 347 955.5 L 346 955.5 L 346.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1385.5 952 L 1386 955.5 L 1385 955.5 L 1385.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 1700.5 952 L 1701 956.5 L 1700 956.5 L 1700.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 218.5 954 L 219 957.5 L 218 957.5 L 218.5 954 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1606.5 955 L 1607 958.5 L 1606 958.5 L 1606.5 955 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 123.5 956 L 124 959.5 L 123 959.5 L 123.5 956 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 440.5 956 L 441 959.5 L 440 959.5 L 440.5 956 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1478.5 956 L 1479 959.5 L 1478 959.5 L 1478.5 956 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 523.5 957 L 524.5 959 L 523.5 957 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 943.5 957 L 944.5 959 L 943.5 957 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 1021.5 957 L 1020.5 959 L 1021.5 957 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 600.5 958 L 599.5 960 L 600.5 958 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 345.5 960 L 346 963.5 L 345 963.5 L 345.5 960 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 526.5 961 L 532.5 968 L 526.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 598.5 961 L 592.5 968 L 598.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 946.5 961 L 952.5 968 L 946.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 1018.5 961 L 1012.5 968 L 1018.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1386.5 961 L 1387 964.5 L 1386 964.5 L 1386.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 1701.5 961 L 1702 964.5 L 1701 964.5 L 1701.5 961 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 217.5 962 L 218 965.5 L 217 965.5 L 217.5 962 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1607.5 963 L 1608 967.5 L 1607 967.5 L 1607.5 963 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 122.5 964 L 123 967.5 L 122 967.5 L 122.5 964 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 439.5 964 L 440 967.5 L 439 967.5 L 439.5 964 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1479.5 964 L 1480 967.5 L 1479 967.5 L 1479.5 964 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 344.5 968 L 345 972.5 L 344 972.5 L 344.5 968 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 590.5 968 L 589.5 970 L 590.5 968 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 535.5 969 L 536.5 971 L 535.5 969 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 1387.5 969 L 1388 972.5 L 1387 972.5 L 1387.5 969 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1702.5 969 L 1703 972.5 L 1702 972.5 L 1702.5 969 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 216.5 971 L 217 974.5 L 216 974.5 L 216.5 971 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 121.5 972 L 122 975.5 L 121 975.5 L 121.5 972 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 438.5 972 L 439 976.5 L 438 976.5 L 438.5 972 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1480.5 972 L 1481 975.5 L 1480 975.5 L 1480.5 972 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1608.5 972 L 1609 975.5 L 1608 975.5 L 1608.5 972 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 343.5 977 L 344 980.5 L 343 980.5 L 343.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 553.5 977 L 556 977.5 L 553.5 978 L 553.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 569.5 977 L 572 977.5 L 569.5 978 L 569.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 973.5 977 L 976 977.5 L 973.5 978 L 973.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 989.5 977 L 992 977.5 L 989.5 978 L 989.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1388.5 977 L 1389 980.5 L 1388 980.5 L 1388.5 977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1703.5 978 L 1704 981.5 L 1703 981.5 L 1703.5 978 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 215.5 979 L 216 982.5 L 215 982.5 L 215.5 979 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 120.5 980 L 121 984.5 L 120 984.5 L 120.5 980 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 1481.5 980 L 1482 983.5 L 1481 983.5 L 1481.5 980 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1609.5 980 L 1610 983.5 L 1609 983.5 L 1609.5 980 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 437.5 981 L 438 984.5 L 437 984.5 L 437.5 981 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 342.5 985 L 343 988.5 L 342 988.5 L 342.5 985 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 1389.5 985 L 1390 988.5 L 1389 988.5 L 1389.5 985 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1704.5 986 L 1705 989.5 L 1704 989.5 L 1704.5 986 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 214.5 987 L 215 990.5 L 214 990.5 L 214.5 987 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1482.5 988 L 1483 991.5 L 1482 991.5 L 1482.5 988 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1610.5 988 L 1611 991.5 L 1610 991.5 L 1610.5 988 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 119.5 989 L 120 992.5 L 119 992.5 L 119.5 989 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 436.5 989 L 437 992.5 L 436 992.5 L 436.5 989 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 341.5 993 L 342 996.5 L 341 996.5 L 341.5 993 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1390.5 993 L 1391 996.5 L 1390 996.5 L 1390.5 993 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1705.5 994 L 1706 998.5 L 1705 998.5 L 1705.5 994 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 213.5 995 L 214 999.5 L 213 999.5 L 213.5 995 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 118.5 997 L 119 1000.5 L 118 1000.5 L 118.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 435.5 997 L 436 1000.5 L 435 1000.5 L 435.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1483.5 997 L 1484 1000.5 L 1483 1000.5 L 1483.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 1611.5 997 L 1612 1000.5 L 1611 1000.5 L 1611.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 340.5 1001 L 341 1004.5 L 340 1004.5 L 340.5 1001 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 1391.5 1002 L 1392 1005.5 L 1391 1005.5 L 1391.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1706.5 1003 L 1707 1006.5 L 1706 1006.5 L 1706.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 212.5 1004 L 213 1007.5 L 212 1007.5 L 212.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 117.5 1005 L 118 1009.5 L 117 1009.5 L 117.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 434.5 1005 L 435 1008.5 L 434 1008.5 L 434.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1484.5 1005 L 1485 1008.5 L 1484 1008.5 L 1484.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 1612.5 1005 L 1613 1008.5 L 1612 1008.5 L 1612.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 622.5 1008 L 639 1008.5 L 622.5 1009 L 622.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 901.5 1008 L 924 1008.5 L 901.5 1009 L 901.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1186.5 1008 L 1203 1008.5 L 1186.5 1009 L 1186.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 646.5 1009 L 650 1009.5 L 646.5 1010 L 646.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 890.5 1009 L 894 1009.5 L 890.5 1010 L 890.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 930.5 1009 L 935 1009.5 L 930.5 1010 L 930.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 1175.5 1009 L 1179 1009.5 L 1175.5 1010 L 1175.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 339.5 1010 L 340 1013.5 L 339 1013.5 L 339.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 654.5 1010 L 657 1010.5 L 654.5 1011 L 654.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 883.5 1010 L 886 1010.5 L 883.5 1011 L 883.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 939.5 1010 L 942 1010.5 L 939.5 1011 L 939.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 1168.5 1010 L 1171 1010.5 L 1168.5 1011 L 1168.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 1392.5 1010 L 1393 1013.5 L 1392 1013.5 L 1392.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 660.5 1011 L 663 1011.5 L 660.5 1012 L 660.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 877.5 1011 L 880 1011.5 L 877.5 1012 L 877.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 945.5 1011 L 948 1011.5 L 945.5 1012 L 945.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 1162.5 1011 L 1165 1011.5 L 1162.5 1012 L 1162.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 1707.5 1011 L 1708 1014.5 L 1707 1014.5 L 1707.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 211.5 1012 L 212 1015.5 L 211 1015.5 L 211.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 872.5 1012 L 875 1012.5 L 872.5 1013 L 872.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 433.5 1013 L 434 1017.5 L 433 1017.5 L 433.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1485.5 1013 L 1486 1016.5 L 1485 1016.5 L 1485.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1613.5 1013 L 1614 1016.5 L 1613 1016.5 L 1613.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 116.5 1014 L 117 1017.5 L 116 1017.5 L 116.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 601.5 1016 L 600.5 1018 L 601.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 1223.5 1016 L 1224.5 1018 L 1223.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 338.5 1018 L 339 1021.5 L 338 1021.5 L 338.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 598.5 1018 L 591.5 1026 L 598.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 1226.5 1018 L 1233.5 1026 L 1226.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1393.5 1018 L 1394 1021.5 L 1393 1021.5 L 1393.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 210.5 1020 L 211 1024.5 L 210 1024.5 L 210.5 1020 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 1708.5 1020 L 1709 1023.5 L 1708 1023.5 L 1708.5 1020 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 1486.5 1021 L 1487 1024.5 L 1486 1024.5 L 1486.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1614.5 1021 L 1615 1025.5 L 1614 1025.5 L 1614.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 115.5 1022 L 116 1025.5 L 115 1025.5 L 115.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 432.5 1022 L 433 1025.5 L 432 1025.5 L 432.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 699.5 1024 L 700.5 1026 L 699.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 1125.5 1024 L 1124.5 1026 L 1125.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 337.5 1026 L 338 1029.5 L 337 1029.5 L 337.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 1394.5 1026 L 1395 1029.5 L 1394 1029.5 L 1394.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1709.5 1028 L 1710 1031.5 L 1709 1031.5 L 1709.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 209.5 1029 L 210 1032.5 L 209 1032.5 L 209.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 1487.5 1029 L 1488 1032.5 L 1487 1032.5 L 1487.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 114.5 1030 L 115 1034.5 L 114 1034.5 L 114.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 431.5 1030 L 432 1033.5 L 431 1033.5 L 431.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 1615.5 1030 L 1616 1033.5 L 1615 1033.5 L 1615.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 711.5 1031 L 712.5 1033 L 711.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 1113.5 1031 L 1112.5 1033 L 1113.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 999.5 1033 L 1000.5 1035 L 999.5 1033 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 336.5 1034 L 337 1037.5 L 336 1037.5 L 336.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 1395.5 1034 L 1396 1037.5 L 1395 1037.5 L 1395.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 1002.5 1035 L 1003.5 1037 L 1002.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 820.5 1036 L 819.5 1038 L 820.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 1710.5 1036 L 1711 1040.5 L 1710 1040.5 L 1710.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 208.5 1037 L 209 1040.5 L 208 1040.5 L 208.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1005.5 1037 L 1006.5 1039 L 1005.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 1488.5 1037 L 1489 1040.5 L 1488 1040.5 L 1488.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 430.5 1038 L 431 1041.5 L 430 1041.5 L 430.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 1616.5 1038 L 1617 1041.5 L 1616 1041.5 L 1616.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 113.5 1039 L 114 1042.5 L 113 1042.5 L 113.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 816.5 1039 L 815.5 1041 L 816.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 1008.5 1039 L 1009.5 1041 L 1008.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 726.5 1041 L 727.5 1043 L 726.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 813.5 1041 L 812.5 1043 L 813.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 1011.5 1041 L 1012.5 1043 L 1011.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 1098.5 1041 L 1097.5 1043 L 1098.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 335.5 1042 L 336 1046.5 L 335 1046.5 L 335.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 729.5 1043 L 730.5 1045 L 729.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 1095.5 1043 L 1094.5 1045 L 1095.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 1396.5 1043 L 1397 1046.5 L 1396 1046.5 L 1396.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 809.5 1044 L 808.5 1046 L 809.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 1015.5 1044 L 1016.5 1046 L 1015.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 207.5 1045 L 208 1049.5 L 207 1049.5 L 207.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 732.5 1045 L 733.5 1047 L 732.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 1092.5 1045 L 1091.5 1047 L 1092.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1711.5 1045 L 1712 1048.5 L 1711 1048.5 L 1711.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 429.5 1046 L 430 1049.5 L 429 1049.5 L 429.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 806.5 1046 L 805.5 1048 L 806.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1018.5 1046 L 1019.5 1048 L 1018.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 1489.5 1046 L 1490 1049.5 L 1489 1049.5 L 1489.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 1617.5 1046 L 1618 1049.5 L 1617 1049.5 L 1617.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 112.5 1047 L 113 1050.5 L 112 1050.5 L 112.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 581.5 1047 L 582 1050.5 L 581 1050.5 L 581.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 1243.5 1047 L 1244 1050.5 L 1243 1050.5 L 1243.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 334.5 1051 L 335 1054.5 L 334 1054.5 L 334.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 1397.5 1051 L 1398 1054.5 L 1397 1054.5 L 1397.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 1712.5 1053 L 1713 1056.5 L 1712 1056.5 L 1712.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 206.5 1054 L 207 1057.5 L 206 1057.5 L 206.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 428.5 1054 L 429 1058.5 L 428 1058.5 L 428.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 1490.5 1054 L 1491 1057.5 L 1490 1057.5 L 1490.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 111.5 1055 L 112 1059.5 L 111 1059.5 L 111.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1618.5 1055 L 1619 1058.5 L 1618 1058.5 L 1618.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 755.5 1056 L 758 1056.5 L 755.5 1057 L 755.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 782.5 1056 L 785 1056.5 L 782.5 1057 L 782.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 1040.5 1056 L 1043 1056.5 L 1040.5 1057 L 1040.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 1067.5 1056 L 1070 1056.5 L 1067.5 1057 L 1067.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 763.5 1057 L 777 1057.5 L 763.5 1058 L 763.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1048.5 1057 L 1062 1057.5 L 1048.5 1058 L 1048.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 333.5 1059 L 334 1062.5 L 333 1062.5 L 333.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 581.5 1059 L 582 1062.5 L 581 1062.5 L 581.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 1243.5 1059 L 1244 1062.5 L 1243 1062.5 L 1243.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 1398.5 1059 L 1399 1062.5 L 1398 1062.5 L 1398.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 205.5 1062 L 206 1065.5 L 205 1065.5 L 205.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 1491.5 1062 L 1492 1065.5 L 1491 1065.5 L 1491.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 1713.5 1062 L 1714 1065.5 L 1713 1065.5 L 1713.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 427.5 1063 L 428 1066.5 L 427 1066.5 L 427.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 1619.5 1063 L 1620 1066.5 L 1619 1066.5 L 1619.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 110.5 1064 L 111 1067.5 L 110 1067.5 L 110.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 332.5 1067 L 333 1070.5 L 332 1070.5 L 332.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 1399.5 1067 L 1400 1070.5 L 1399 1070.5 L 1399.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 204.5 1070 L 205 1074.5 L 204 1074.5 L 204.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1492.5 1070 L 1493 1073.5 L 1492 1073.5 L 1492.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 1714.5 1070 L 1715 1073.5 L 1714 1073.5 L 1714.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 426.5 1071 L 427 1074.5 L 426 1074.5 L 426.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 1620.5 1071 L 1621 1074.5 L 1620 1074.5 L 1620.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 109.5 1072 L 110 1075.5 L 109 1075.5 L 109.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 331.5 1075 L 332 1078.5 L 331 1078.5 L 331.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 1400.5 1075 L 1401 1078.5 L 1400 1078.5 L 1400.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 1493.5 1078 L 1494 1081.5 L 1493 1081.5 L 1493.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1715.5 1078 L 1716 1082.5 L 1715 1082.5 L 1715.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 203.5 1079 L 204 1082.5 L 203 1082.5 L 203.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 425.5 1079 L 426 1082.5 L 425 1082.5 L 425.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 1621.5 1079 L 1622 1083.5 L 1621 1083.5 L 1621.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 108.5 1080 L 109 1083.5 L 108 1083.5 L 108.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 588.5 1080 L 589.5 1082 L 588.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 1236.5 1080 L 1235.5 1082 L 1236.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 590.5 1083 L 599.5 1093 L 590.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 1234.5 1083 L 1225.5 1093 L 1234.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 330.5 1084 L 331 1087.5 L 330 1087.5 L 330.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 1401.5 1084 L 1402 1087.5 L 1401 1087.5 L 1401.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 1494.5 1086 L 1495 1089.5 L 1494 1089.5 L 1494.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 202.5 1087 L 203 1090.5 L 202 1090.5 L 202.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 424.5 1087 L 425 1090.5 L 424 1090.5 L 424.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 1716.5 1087 L 1717 1090.5 L 1716 1090.5 L 1716.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 1622.5 1088 L 1623 1091.5 L 1622 1091.5 L 1622.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 107.5 1089 L 108 1092.5 L 107 1092.5 L 107.5 1089 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 329.5 1092 L 330 1095.5 L 329 1095.5 L 329.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 1402.5 1092 L 1403 1095.5 L 1402 1095.5 L 1402.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 601.5 1093 L 602.5 1095 L 601.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 1223.5 1093 L 1222.5 1095 L 1223.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 1495.5 1094 L 1496 1098.5 L 1495 1098.5 L 1495.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 201.5 1095 L 202 1098.5 L 201 1098.5 L 201.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 423.5 1095 L 424 1099.5 L 423 1099.5 L 423.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 1717.5 1095 L 1718 1098.5 L 1717 1098.5 L 1717.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 1623.5 1096 L 1624 1099.5 L 1623 1099.5 L 1623.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 106.5 1097 L 107 1100.5 L 106 1100.5 L 106.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 328.5 1100 L 329 1103.5 L 328 1103.5 L 328.5 1100 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 1403.5 1100 L 1404 1103.5 L 1403 1103.5 L 1403.5 1100 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 620.5 1101 L 626 1101.5 L 620.5 1102 L 620.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 1199.5 1101 L 1205 1101.5 L 1199.5 1102 L 1199.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 638.5 1102 L 641 1102.5 L 638.5 1103 L 638.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 899.5 1102 L 903 1102.5 L 899.5 1103 L 899.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 922.5 1102 L 926 1102.5 L 922.5 1103 L 922.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 1184.5 1102 L 1187 1102.5 L 1184.5 1103 L 1184.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1496.5 1103 L 1497 1106.5 L 1496 1106.5 L 1496.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 1718.5 1103 L 1719 1107.5 L 1718 1107.5 L 1718.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 200.5 1104 L 201 1107.5 L 200 1107.5 L 200.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 422.5 1104 L 423 1107.5 L 422 1107.5 L 422.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 1624.5 1104 L 1625 1107.5 L 1624 1107.5 L 1624.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 105.5 1105 L 106 1108.5 L 105 1108.5 L 105.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 327.5 1108 L 328 1111.5 L 327 1111.5 L 327.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 882.5 1108 L 881.5 1110 L 882.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 942.5 1108 L 943.5 1110 L 942.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 1404.5 1108 L 1405 1111.5 L 1404 1111.5 L 1404.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 659.5 1109 L 660.5 1111 L 659.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 1165.5 1109 L 1164.5 1111 L 1165.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 877.5 1111 L 876.5 1113 L 877.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 947.5 1111 L 948.5 1113 L 947.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 1497.5 1111 L 1498 1114.5 L 1497 1114.5 L 1497.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 199.5 1112 L 200 1115.5 L 199 1115.5 L 199.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 421.5 1112 L 422 1115.5 L 421 1115.5 L 421.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 1719.5 1112 L 1720 1115.5 L 1719 1115.5 L 1719.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 665.5 1113 L 666.5 1115 L 665.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 874.5 1113 L 873.5 1115 L 874.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 950.5 1113 L 951.5 1115 L 950.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 1159.5 1113 L 1158.5 1115 L 1159.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 1625.5 1113 L 1626 1116.5 L 1625 1116.5 L 1625.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 104.5 1114 L 105 1117.5 L 104 1117.5 L 104.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 668.5 1115 L 669.5 1117 L 668.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 1156.5 1115 L 1155.5 1117 L 1156.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 326.5 1116 L 327 1120.5 L 326 1120.5 L 326.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 870.5 1116 L 869.5 1118 L 870.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 954.5 1116 L 955.5 1118 L 954.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 1405.5 1116 L 1406 1119.5 L 1405 1119.5 L 1405.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 867.5 1118 L 866.5 1120 L 867.5 1118 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 957.5 1118 L 958.5 1120 L 957.5 1118 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 1498.5 1119 L 1499 1122.5 L 1498 1122.5 L 1498.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 198.5 1120 L 199 1123.5 L 198 1123.5 L 198.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 420.5 1120 L 421 1123.5 L 420 1123.5 L 420.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 864.5 1120 L 863.5 1122 L 864.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 960.5 1120 L 961.5 1122 L 960.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 1720.5 1120 L 1721 1123.5 L 1720 1123.5 L 1720.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 1626.5 1121 L 1627 1124.5 L 1626 1124.5 L 1626.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 103.5 1122 L 104 1125.5 L 103 1125.5 L 103.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 861.5 1122 L 860.5 1124 L 861.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 963.5 1122 L 964.5 1124 L 963.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 858.5 1124 L 857.5 1126 L 858.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 966.5 1124 L 967.5 1126 L 966.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 325.5 1125 L 326 1128.5 L 325 1128.5 L 325.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 683.5 1125 L 684.5 1127 L 683.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 1141.5 1125 L 1140.5 1127 L 1141.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 1406.5 1125 L 1407 1128.5 L 1406 1128.5 L 1406.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 686.5 1127 L 687.5 1129 L 686.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1138.5 1127 L 1137.5 1129 L 1138.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 1499.5 1127 L 1500 1130.5 L 1499 1130.5 L 1499.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 419.5 1128 L 420 1131.5 L 419 1131.5 L 419.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 197.5 1129 L 198 1132.5 L 197 1132.5 L 197.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 850.5 1129 L 849.5 1131 L 850.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 974.5 1129 L 975.5 1131 L 974.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 1627.5 1129 L 1628 1132.5 L 1627 1132.5 L 1627.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 1721.5 1129 L 1722 1132.5 L 1721 1132.5 L 1721.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 102.5 1130 L 103 1133.5 L 102 1133.5 L 102.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 691.5 1130 L 692.5 1132 L 691.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 1133.5 1130 L 1132.5 1132 L 1133.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 324.5 1133 L 325 1136.5 L 324 1136.5 L 324.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 1407.5 1133 L 1408 1136.5 L 1407 1136.5 L 1407.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1500.5 1135 L 1501 1138.5 L 1500 1138.5 L 1500.5 1135 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 418.5 1136 L 419 1140.5 L 418 1140.5 L 418.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 196.5 1137 L 197 1140.5 L 196 1140.5 L 196.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 1722.5 1137 L 1723 1140.5 L 1722 1140.5 L 1722.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 1628.5 1138 L 1629 1141.5 L 1628 1141.5 L 1628.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 101.5 1139 L 102 1142.5 L 101 1142.5 L 101.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 323.5 1141 L 324 1144.5 L 323 1144.5 L 323.5 1141 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 1408.5 1141 L 1409 1144.5 L 1408 1144.5 L 1408.5 1141 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 1501.5 1143 L 1502 1147.5 L 1501 1147.5 L 1501.5 1143 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 195.5 1145 L 196 1148.5 L 195 1148.5 L 195.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 417.5 1145 L 418 1148.5 L 417 1148.5 L 417.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 1723.5 1145 L 1724 1149.5 L 1723 1149.5 L 1723.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 729.5 1146 L 732 1146.5 L 729.5 1147 L 729.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 1093.5 1146 L 1096 1146.5 L 1093.5 1147 L 1093.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 1629.5 1146 L 1630 1149.5 L 1629 1149.5 L 1629.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 100.5 1147 L 101 1150.5 L 100 1150.5 L 100.5 1147 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 739.5 1148 L 742 1148.5 L 739.5 1149 L 739.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 798.5 1148 L 801 1148.5 L 798.5 1149 L 798.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 1024.5 1148 L 1027 1148.5 L 1024.5 1149 L 1024.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 1083.5 1148 L 1086 1148.5 L 1083.5 1149 L 1083.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 322.5 1149 L 323 1152.5 L 322 1152.5 L 322.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 745.5 1149 L 750 1149.5 L 745.5 1150 L 745.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 791.5 1149 L 795 1149.5 L 791.5 1150 L 791.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 1030.5 1149 L 1034 1149.5 L 1030.5 1150 L 1030.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 1075.5 1149 L 1080 1149.5 L 1075.5 1150 L 1075.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 1409.5 1149 L 1410 1152.5 L 1409 1152.5 L 1409.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 755.5 1150 L 765 1150.5 L 755.5 1151 L 755.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 775.5 1150 L 785 1150.5 L 775.5 1151 L 775.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 1040.5 1150 L 1050 1150.5 L 1040.5 1151 L 1040.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 1060.5 1150 L 1070 1150.5 L 1060.5 1151 L 1060.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 1502.5 1152 L 1503 1155.5 L 1502 1155.5 L 1502.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 416.5 1153 L 417 1156.5 L 416 1156.5 L 416.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 194.5 1154 L 195 1157.5 L 194 1157.5 L 194.5 1154 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 1630.5 1154 L 1631 1157.5 L 1630 1157.5 L 1630.5 1154 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 1724.5 1154 L 1725 1157.5 L 1724 1157.5 L 1724.5 1154 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 99.5 1155 L 100 1158.5 L 99 1158.5 L 99.5 1155 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 1410.5 1157 L 1411 1160.5 L 1410 1160.5 L 1410.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 321.5 1158 L 322 1161.5 L 321 1161.5 L 321.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 1503.5 1160 L 1504 1163.5 L 1503 1163.5 L 1503.5 1160 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 415.5 1161 L 416 1164.5 L 415 1164.5 L 415.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 193.5 1162 L 194 1165.5 L 193 1165.5 L 193.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 1631.5 1162 L 1632 1166.5 L 1631 1166.5 L 1631.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 1725.5 1162 L 1726 1165.5 L 1725 1165.5 L 1725.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 98.5 1164 L 99 1167.5 L 98 1167.5 L 98.5 1164 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 320.5 1166 L 321 1169.5 L 320 1169.5 L 320.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 1411.5 1166 L 1412 1169.5 L 1411 1169.5 L 1411.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 1504.5 1168 L 1505 1171.5 L 1504 1171.5 L 1504.5 1168 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 414.5 1169 L 415 1172.5 L 414 1172.5 L 414.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 192.5 1170 L 193 1173.5 L 192 1173.5 L 192.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 1632.5 1171 L 1633 1174.5 L 1632 1174.5 L 1632.5 1171 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 1726.5 1171 L 1727 1174.5 L 1726 1174.5 L 1726.5 1171 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 97.5 1172 L 98 1175.5 L 97 1175.5 L 97.5 1172 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 319.5 1174 L 320 1177.5 L 319 1177.5 L 319.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 1412.5 1174 L 1413 1177.5 L 1412 1177.5 L 1412.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1505.5 1176 L 1506 1179.5 L 1505 1179.5 L 1505.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 413.5 1177 L 414 1181.5 L 413 1181.5 L 413.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 191.5 1178 L 192 1182.5 L 191 1182.5 L 191.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 1633.5 1179 L 1634 1182.5 L 1633 1182.5 L 1633.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 1727.5 1179 L 1728 1182.5 L 1727 1182.5 L 1727.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 96.5 1180 L 97 1183.5 L 96 1183.5 L 96.5 1180 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 318.5 1182 L 319 1185.5 L 318 1185.5 L 318.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 1413.5 1182 L 1414 1185.5 L 1413 1185.5 L 1413.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 1506.5 1184 L 1507 1187.5 L 1506 1187.5 L 1506.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 412.5 1186 L 413 1189.5 L 412 1189.5 L 412.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 190.5 1187 L 191 1190.5 L 190 1190.5 L 190.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1634.5 1187 L 1635 1190.5 L 1634 1190.5 L 1634.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 1728.5 1187 L 1729 1191.5 L 1728 1191.5 L 1728.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 95.5 1188 L 96 1192.5 L 95 1192.5 L 95.5 1188 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 317.5 1190 L 318 1194.5 L 317 1194.5 L 317.5 1190 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 1414.5 1190 L 1415 1193.5 L 1414 1193.5 L 1414.5 1190 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 1507.5 1192 L 1508 1195.5 L 1507 1195.5 L 1507.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 411.5 1194 L 412 1197.5 L 411 1197.5 L 411.5 1194 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 189.5 1195 L 190 1198.5 L 189 1198.5 L 189.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 1635.5 1196 L 1636 1199.5 L 1635 1199.5 L 1635.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 1729.5 1196 L 1730 1199.5 L 1729 1199.5 L 1729.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 94.5 1197 L 95 1200.5 L 94 1200.5 L 94.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 1415.5 1198 L 1416 1201.5 L 1415 1201.5 L 1415.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 316.5 1199 L 317 1202.5 L 316 1202.5 L 316.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 1508.5 1201 L 1509 1204.5 L 1508 1204.5 L 1508.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 410.5 1202 L 411 1205.5 L 410 1205.5 L 410.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 188.5 1203 L 189 1207.5 L 188 1207.5 L 188.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 1636.5 1204 L 1637 1207.5 L 1636 1207.5 L 1636.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 1730.5 1204 L 1731 1207.5 L 1730 1207.5 L 1730.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 93.5 1205 L 94 1208.5 L 93 1208.5 L 93.5 1205 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 315.5 1207 L 316 1210.5 L 315 1210.5 L 315.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 1416.5 1207 L 1417 1210.5 L 1416 1210.5 L 1416.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 1509.5 1209 L 1510 1212.5 L 1509 1212.5 L 1509.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 409.5 1210 L 410 1213.5 L 409 1213.5 L 409.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 187.5 1212 L 188 1215.5 L 187 1215.5 L 187.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 1637.5 1212 L 1638 1215.5 L 1637 1215.5 L 1637.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 92.5 1213 L 93 1217.5 L 92 1217.5 L 92.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 1731.5 1213 L 1732 1216.5 L 1731 1216.5 L 1731.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 314.5 1215 L 315 1218.5 L 314 1218.5 L 314.5 1215 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 1417.5 1215 L 1418 1218.5 L 1417 1218.5 L 1417.5 1215 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 1510.5 1217 L 1511 1220.5 L 1510 1220.5 L 1510.5 1217 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 408.5 1218 L 409 1222.5 L 408 1222.5 L 408.5 1218 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 186.5 1220 L 187 1223.5 L 186 1223.5 L 186.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 1638.5 1220 L 1639 1224.5 L 1638 1224.5 L 1638.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 1732.5 1221 L 1733 1224.5 L 1732 1224.5 L 1732.5 1221 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 91.5 1222 L 92 1225.5 L 91 1225.5 L 91.5 1222 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 313.5 1223 L 314 1226.5 L 313 1226.5 L 313.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 1418.5 1223 L 1419 1226.5 L 1418 1226.5 L 1418.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 1511.5 1225 L 1512 1228.5 L 1511 1228.5 L 1511.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 407.5 1227 L 408 1230.5 L 407 1230.5 L 407.5 1227 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 185.5 1228 L 186 1232.5 L 185 1232.5 L 185.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 1639.5 1229 L 1640 1232.5 L 1639 1232.5 L 1639.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 1733.5 1229 L 1734 1233.5 L 1733 1233.5 L 1733.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 90.5 1230 L 91 1233.5 L 90 1233.5 L 90.5 1230 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1419.5 1231 L 1420 1234.5 L 1419 1234.5 L 1419.5 1231 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 312.5 1232 L 313 1235.5 L 312 1235.5 L 312.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 1512.5 1233 L 1513 1236.5 L 1512 1236.5 L 1512.5 1233 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 406.5 1235 L 407 1238.5 L 406 1238.5 L 406.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 184.5 1237 L 185 1240.5 L 184 1240.5 L 184.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 1640.5 1237 L 1641 1240.5 L 1640 1240.5 L 1640.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 89.5 1238 L 90 1242.5 L 89 1242.5 L 89.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 1734.5 1238 L 1735 1241.5 L 1734 1241.5 L 1734.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 1420.5 1239 L 1421 1242.5 L 1420 1242.5 L 1420.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 311.5 1240 L 312 1243.5 L 311 1243.5 L 311.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 1513.5 1241 L 1514 1244.5 L 1513 1244.5 L 1513.5 1241 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 405.5 1243 L 406 1246.5 L 405 1246.5 L 405.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 183.5 1245 L 184 1248.5 L 183 1248.5 L 183.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 1641.5 1245 L 1642 1248.5 L 1641 1248.5 L 1641.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 1735.5 1246 L 1736 1249.5 L 1735 1249.5 L 1735.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 88.5 1247 L 89 1250.5 L 88 1250.5 L 88.5 1247 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 310.5 1248 L 311 1251.5 L 310 1251.5 L 310.5 1248 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 1421.5 1248 L 1422 1251.5 L 1421 1251.5 L 1421.5 1248 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 1514.5 1250 L 1515 1253.5 L 1514 1253.5 L 1514.5 1250 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 404.5 1251 L 405 1254.5 L 404 1254.5 L 404.5 1251 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 182.5 1253 L 183 1257.5 L 182 1257.5 L 182.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 1642.5 1254 L 1643 1257.5 L 1642 1257.5 L 1642.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 87.5 1255 L 88 1258.5 L 87 1258.5 L 87.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 1736.5 1255 L 1737 1258.5 L 1736 1258.5 L 1736.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 309.5 1256 L 310 1259.5 L 309 1259.5 L 309.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 621.5 1256 L 624 1256.5 L 621.5 1257 L 621.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 644.5 1256 L 650 1256.5 L 644.5 1257 L 644.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 895.5 1256 L 901 1256.5 L 895.5 1257 L 895.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 928.5 1256 L 934 1256.5 L 928.5 1257 L 928.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 1180.5 1256 L 1186 1256.5 L 1180.5 1257 L 1180.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 1206.5 1256 L 1209 1256.5 L 1206.5 1257 L 1206.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 1422.5 1256 L 1423 1259.5 L 1422 1259.5 L 1422.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 654.5 1257 L 657 1257.5 L 654.5 1258 L 654.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 887.5 1257 L 891 1257.5 L 887.5 1258 L 887.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 939.5 1257 L 942 1257.5 L 939.5 1258 L 939.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 1172.5 1257 L 1176 1257.5 L 1172.5 1258 L 1172.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 945.5 1258 L 948 1258.5 L 945.5 1259 L 945.5 1258 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 1166.5 1258 L 1169 1258.5 L 1166.5 1259 L 1166.5 1258 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 1515.5 1258 L 1516 1261.5 L 1515 1261.5 L 1515.5 1258 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 403.5 1259 L 404 1263.5 L 403 1263.5 L 403.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 1161.5 1259 L 1164 1259.5 L 1161.5 1260 L 1161.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 181.5 1262 L 182 1265.5 L 181 1265.5 L 181.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 1643.5 1262 L 1644 1265.5 L 1643 1265.5 L 1643.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 86.5 1263 L 87 1267.5 L 86 1267.5 L 86.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 1225.5 1263 L 1226.5 1265 L 1225.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 1737.5 1263 L 1738 1266.5 L 1737 1266.5 L 1737.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 308.5 1264 L 309 1268.5 L 308 1268.5 L 308.5 1264 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 1423.5 1264 L 1424 1267.5 L 1423 1267.5 L 1423.5 1264 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 601.5 1265 L 599.5 1268 L 601.5 1265 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 1229.5 1266 L 1235.5 1273 L 1229.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 1516.5 1266 L 1517 1269.5 L 1516 1269.5 L 1516.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 402.5 1268 L 403 1271.5 L 402 1271.5 L 402.5 1268 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 180.5 1270 L 181 1273.5 L 180 1273.5 L 180.5 1270 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 1644.5 1270 L 1645 1273.5 L 1644 1273.5 L 1644.5 1270 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 595.5 1271 L 592.5 1275 L 595.5 1271 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 1128.5 1271 L 1127.5 1273 L 1128.5 1271 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 1738.5 1271 L 1739 1275.5 L 1738 1275.5 L 1738.5 1271 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 85.5 1272 L 86 1275.5 L 85 1275.5 L 85.5 1272 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 1424.5 1272 L 1425 1275.5 L 1424 1275.5 L 1424.5 1272 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 307.5 1273 L 308 1276.5 L 307 1276.5 L 307.5 1273 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 1517.5 1274 L 1518 1277.5 L 1517 1277.5 L 1517.5 1274 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 1237.5 1275 L 1238.5 1277 L 1237.5 1275 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 401.5 1276 L 402 1279.5 L 401 1279.5 L 401.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 591.5 1276 L 590.5 1278 L 591.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 179.5 1278 L 180 1281.5 L 179 1281.5 L 179.5 1278 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 1645.5 1278 L 1646 1282.5 L 1645 1282.5 L 1645.5 1278 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 999.5 1279 L 1000.5 1281 L 999.5 1279 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 84.5 1280 L 85 1283.5 L 84 1283.5 L 84.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 716.5 1280 L 717.5 1282 L 716.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 828.5 1280 L 827.5 1282 L 828.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 1425.5 1280 L 1426 1283.5 L 1425 1283.5 L 1425.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 1739.5 1280 L 1740 1283.5 L 1739 1283.5 L 1739.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 306.5 1281 L 307 1284.5 L 306 1284.5 L 306.5 1281 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 719.5 1282 L 720.5 1284 L 719.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 825.5 1282 L 824.5 1284 L 825.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 1518.5 1282 L 1519 1285.5 L 1518 1285.5 L 1518.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_931"
          d="M 1108.5 1283 L 1107.5 1285 L 1108.5 1283 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_932"
          d="M 400.5 1284 L 401 1287.5 L 400 1287.5 L 400.5 1284 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_933"
          d="M 722.5 1284 L 723.5 1286 L 722.5 1284 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_934"
          d="M 822.5 1284 L 821.5 1286 L 822.5 1284 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_935"
          d="M 1105.5 1285 L 1104.5 1287 L 1105.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_936"
          d="M 725.5 1286 L 726.5 1288 L 725.5 1286 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_937"
          d="M 819.5 1286 L 818.5 1288 L 819.5 1286 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_938"
          d="M 178.5 1287 L 179 1290.5 L 178 1290.5 L 178.5 1287 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_939"
          d="M 1102.5 1287 L 1101.5 1289 L 1102.5 1287 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_940"
          d="M 1646.5 1287 L 1647 1290.5 L 1646 1290.5 L 1646.5 1287 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_941"
          d="M 83.5 1288 L 84 1291.5 L 83 1291.5 L 83.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_942"
          d="M 728.5 1288 L 729.5 1290 L 728.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_943"
          d="M 816.5 1288 L 815.5 1290 L 816.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_944"
          d="M 1740.5 1288 L 1741 1291.5 L 1740 1291.5 L 1740.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_945"
          d="M 305.5 1289 L 306 1292.5 L 305 1292.5 L 305.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_946"
          d="M 1014.5 1289 L 1015.5 1291 L 1014.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_947"
          d="M 1426.5 1289 L 1427 1292.5 L 1426 1292.5 L 1426.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_948"
          d="M 813.5 1290 L 812.5 1292 L 813.5 1290 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_949"
          d="M 1098.5 1290 L 1097.5 1292 L 1098.5 1290 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_950"
          d="M 1519.5 1290 L 1520 1293.5 L 1519 1293.5 L 1519.5 1290 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_951"
          d="M 584.5 1291 L 585 1293.5 L 584 1293.5 L 584.5 1291 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_952"
          d="M 1017.5 1291 L 1018.5 1293 L 1017.5 1291 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_953"
          d="M 399.5 1292 L 400 1295.5 L 399 1295.5 L 399.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_954"
          d="M 1095.5 1292 L 1094.5 1294 L 1095.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_955"
          d="M 735.5 1293 L 736.5 1295 L 735.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_956"
          d="M 1245.5 1293 L 1246 1295.5 L 1245 1295.5 L 1245.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_957"
          d="M 1092.5 1294 L 1091.5 1296 L 1092.5 1294 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_958"
          d="M 177.5 1295 L 178 1298.5 L 177 1298.5 L 177.5 1295 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_959"
          d="M 1023.5 1295 L 1024.5 1297 L 1023.5 1295 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_960"
          d="M 1647.5 1295 L 1648 1298.5 L 1647 1298.5 L 1647.5 1295 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_961"
          d="M 82.5 1297 L 83 1300.5 L 82 1300.5 L 82.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_962"
          d="M 304.5 1297 L 305 1300.5 L 304 1300.5 L 304.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_963"
          d="M 583.5 1297 L 584 1307.5 L 583 1307.5 L 583.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_964"
          d="M 1427.5 1297 L 1428 1300.5 L 1427 1300.5 L 1427.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_965"
          d="M 1741.5 1297 L 1742 1300.5 L 1741 1300.5 L 1741.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_966"
          d="M 1520.5 1298 L 1521 1302.5 L 1520 1302.5 L 1520.5 1298 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_967"
          d="M 398.5 1300 L 399 1304.5 L 398 1304.5 L 398.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_968"
          d="M 176.5 1303 L 177 1306.5 L 176 1306.5 L 176.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_969"
          d="M 1040.5 1303 L 1043 1303.5 L 1040.5 1304 L 1040.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_970"
          d="M 1071.5 1303 L 1074 1303.5 L 1071.5 1304 L 1071.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_971"
          d="M 1648.5 1303 L 1649 1306.5 L 1648 1306.5 L 1648.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_972"
          d="M 762.5 1304 L 768 1304.5 L 762.5 1305 L 762.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_973"
          d="M 777.5 1304 L 783 1304.5 L 777.5 1305 L 777.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_974"
          d="M 1046.5 1304 L 1053 1304.5 L 1046.5 1305 L 1046.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_975"
          d="M 1061.5 1304 L 1068 1304.5 L 1061.5 1305 L 1061.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_976"
          d="M 81.5 1305 L 82 1308.5 L 81 1308.5 L 81.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_977"
          d="M 303.5 1305 L 304 1309.5 L 303 1309.5 L 303.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_978"
          d="M 1428.5 1305 L 1429 1308.5 L 1428 1308.5 L 1428.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_979"
          d="M 1742.5 1305 L 1743 1308.5 L 1742 1308.5 L 1742.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_980"
          d="M 1521.5 1307 L 1522 1310.5 L 1521 1310.5 L 1521.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_981"
          d="M 397.5 1309 L 398 1312.5 L 397 1312.5 L 397.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_982"
          d="M 1245.5 1309 L 1246 1311.5 L 1245 1311.5 L 1245.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_983"
          d="M 584.5 1311 L 585 1313.5 L 584 1313.5 L 584.5 1311 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_984"
          d="M 175.5 1312 L 176 1315.5 L 175 1315.5 L 175.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_985"
          d="M 1649.5 1312 L 1650 1315.5 L 1649 1315.5 L 1649.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_986"
          d="M 80.5 1313 L 81 1316.5 L 80 1316.5 L 80.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_987"
          d="M 1429.5 1313 L 1430 1316.5 L 1429 1316.5 L 1429.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_988"
          d="M 1743.5 1313 L 1744 1317.5 L 1743 1317.5 L 1743.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_989"
          d="M 302.5 1314 L 303 1317.5 L 302 1317.5 L 302.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_990"
          d="M 1522.5 1315 L 1523 1318.5 L 1522 1318.5 L 1522.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_991"
          d="M 396.5 1317 L 397 1320.5 L 396 1320.5 L 396.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_992"
          d="M 174.5 1320 L 175 1323.5 L 174 1323.5 L 174.5 1320 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_993"
          d="M 1650.5 1320 L 1651 1323.5 L 1650 1323.5 L 1650.5 1320 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_994"
          d="M 1430.5 1321 L 1431 1324.5 L 1430 1324.5 L 1430.5 1321 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_995"
          d="M 79.5 1322 L 80 1325.5 L 79 1325.5 L 79.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_996"
          d="M 301.5 1322 L 302 1325.5 L 301 1325.5 L 301.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_997"
          d="M 1744.5 1322 L 1745 1325.5 L 1744 1325.5 L 1744.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_998"
          d="M 1523.5 1323 L 1524 1326.5 L 1523 1326.5 L 1523.5 1323 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_999"
          d="M 395.5 1325 L 396 1328.5 L 395 1328.5 L 395.5 1325 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1000"
          d="M 590.5 1327 L 591.5 1329 L 590.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1001"
          d="M 173.5 1328 L 174 1331.5 L 173 1331.5 L 173.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1002"
          d="M 1238.5 1328 L 1237.5 1330 L 1238.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1003"
          d="M 1651.5 1328 L 1652 1331.5 L 1651 1331.5 L 1651.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1004"
          d="M 78.5 1330 L 79 1333.5 L 78 1333.5 L 78.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1005"
          d="M 300.5 1330 L 301 1333.5 L 300 1333.5 L 300.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1006"
          d="M 592.5 1330 L 595.5 1334 L 592.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1007"
          d="M 1431.5 1330 L 1432 1333.5 L 1431 1333.5 L 1431.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1008"
          d="M 1745.5 1330 L 1746 1333.5 L 1745 1333.5 L 1745.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1009"
          d="M 1524.5 1331 L 1525 1334.5 L 1524 1334.5 L 1524.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1010"
          d="M 1235.5 1332 L 1229.5 1339 L 1235.5 1332 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1011"
          d="M 394.5 1333 L 395 1336.5 L 394 1336.5 L 394.5 1333 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1012"
          d="M 1652.5 1336 L 1653 1340.5 L 1652 1340.5 L 1652.5 1336 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1013"
          d="M 172.5 1337 L 173 1340.5 L 172 1340.5 L 172.5 1337 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1014"
          d="M 599.5 1337 L 601.5 1340 L 599.5 1337 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1015"
          d="M 77.5 1338 L 78 1341.5 L 77 1341.5 L 77.5 1338 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1016"
          d="M 299.5 1338 L 300 1341.5 L 299 1341.5 L 299.5 1338 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1017"
          d="M 1432.5 1338 L 1433 1341.5 L 1432 1341.5 L 1432.5 1338 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1018"
          d="M 1525.5 1339 L 1526 1342.5 L 1525 1342.5 L 1525.5 1339 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1019"
          d="M 1746.5 1339 L 1747 1342.5 L 1746 1342.5 L 1746.5 1339 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1020"
          d="M 1226.5 1340 L 1225.5 1342 L 1226.5 1340 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1021"
          d="M 393.5 1341 L 394 1345.5 L 393 1345.5 L 393.5 1341 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1022"
          d="M 1221.5 1343 L 1220.5 1345 L 1221.5 1343 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1023"
          d="M 171.5 1345 L 172 1348.5 L 171 1348.5 L 171.5 1345 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1024"
          d="M 1653.5 1345 L 1654 1348.5 L 1653 1348.5 L 1653.5 1345 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1025"
          d="M 1433.5 1346 L 1434 1349.5 L 1433 1349.5 L 1433.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1026"
          d="M 76.5 1347 L 77 1350.5 L 76 1350.5 L 76.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1027"
          d="M 298.5 1347 L 299 1350.5 L 298 1350.5 L 298.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1028"
          d="M 1526.5 1347 L 1527 1351.5 L 1526 1351.5 L 1526.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1029"
          d="M 1747.5 1347 L 1748 1350.5 L 1747 1350.5 L 1747.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1030"
          d="M 621.5 1348 L 624 1348.5 L 621.5 1349 L 621.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1031"
          d="M 1206.5 1348 L 1209 1348.5 L 1206.5 1349 L 1206.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1032"
          d="M 635.5 1349 L 641 1349.5 L 635.5 1350 L 635.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1033"
          d="M 904.5 1349 L 910 1349.5 L 904.5 1350 L 904.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1034"
          d="M 919.5 1349 L 926 1349.5 L 919.5 1350 L 919.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1035"
          d="M 1189.5 1349 L 1195 1349.5 L 1189.5 1350 L 1189.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1036"
          d="M 392.5 1350 L 393 1353.5 L 392 1353.5 L 392.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1037"
          d="M 644.5 1350 L 647 1350.5 L 644.5 1351 L 644.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1038"
          d="M 929.5 1350 L 932 1350.5 L 929.5 1351 L 929.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1039"
          d="M 170.5 1353 L 171 1356.5 L 170 1356.5 L 170.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1040"
          d="M 1654.5 1353 L 1655 1356.5 L 1654 1356.5 L 1654.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1041"
          d="M 1434.5 1354 L 1435 1357.5 L 1434 1357.5 L 1434.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1042"
          d="M 75.5 1355 L 76 1358.5 L 75 1358.5 L 75.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1043"
          d="M 297.5 1355 L 298 1358.5 L 297 1358.5 L 297.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1044"
          d="M 659.5 1355 L 660.5 1357 L 659.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1045"
          d="M 1748.5 1355 L 1749 1359.5 L 1748 1359.5 L 1748.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1046"
          d="M 1527.5 1356 L 1528 1359.5 L 1527 1359.5 L 1527.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1047"
          d="M 391.5 1358 L 392 1361.5 L 391 1361.5 L 391.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1048"
          d="M 664.5 1358 L 665.5 1360 L 664.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1049"
          d="M 880.5 1358 L 879.5 1360 L 880.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1050"
          d="M 667.5 1360 L 668.5 1362 L 667.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1051"
          d="M 877.5 1360 L 876.5 1362 L 877.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1052"
          d="M 953.5 1361 L 954.5 1363 L 953.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1053"
          d="M 1655.5 1361 L 1656 1364.5 L 1655 1364.5 L 1655.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1054"
          d="M 169.5 1362 L 170 1365.5 L 169 1365.5 L 169.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1055"
          d="M 874.5 1362 L 873.5 1364 L 874.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1056"
          d="M 1435.5 1362 L 1436 1365.5 L 1435 1365.5 L 1435.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1057"
          d="M 74.5 1363 L 75 1366.5 L 74 1366.5 L 74.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1058"
          d="M 296.5 1363 L 297 1366.5 L 296 1366.5 L 296.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1059"
          d="M 956.5 1363 L 957.5 1365 L 956.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1060"
          d="M 1156.5 1364 L 1155.5 1366 L 1156.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1061"
          d="M 1528.5 1364 L 1529 1367.5 L 1528 1367.5 L 1528.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1062"
          d="M 1749.5 1364 L 1750 1367.5 L 1749 1367.5 L 1749.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1063"
          d="M 674.5 1365 L 675.5 1367 L 674.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1064"
          d="M 390.5 1366 L 391 1369.5 L 390 1369.5 L 390.5 1366 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1065"
          d="M 1153.5 1366 L 1152.5 1368 L 1153.5 1366 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1066"
          d="M 677.5 1367 L 678.5 1369 L 677.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1067"
          d="M 1150.5 1368 L 1149.5 1370 L 1150.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1068"
          d="M 680.5 1369 L 681.5 1371 L 680.5 1369 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1069"
          d="M 168.5 1370 L 169 1373.5 L 168 1373.5 L 168.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1070"
          d="M 1147.5 1370 L 1146.5 1372 L 1147.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1071"
          d="M 1656.5 1370 L 1657 1373.5 L 1656 1373.5 L 1656.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1072"
          d="M 295.5 1371 L 296 1374.5 L 295 1374.5 L 295.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1073"
          d="M 683.5 1371 L 684.5 1373 L 683.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1074"
          d="M 1436.5 1371 L 1437 1374.5 L 1436 1374.5 L 1436.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1075"
          d="M 73.5 1372 L 74 1375.5 L 73 1375.5 L 73.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1076"
          d="M 1144.5 1372 L 1143.5 1374 L 1144.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1077"
          d="M 1529.5 1372 L 1530 1375.5 L 1529 1375.5 L 1529.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1078"
          d="M 1750.5 1372 L 1751 1375.5 L 1750 1375.5 L 1750.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1079"
          d="M 971.5 1373 L 972.5 1375 L 971.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1080"
          d="M 389.5 1374 L 390 1377.5 L 389 1377.5 L 389.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1081"
          d="M 691.5 1376 L 692.5 1378 L 691.5 1376 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1082"
          d="M 167.5 1378 L 168 1381.5 L 167 1381.5 L 167.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1083"
          d="M 1657.5 1378 L 1658 1381.5 L 1657 1381.5 L 1657.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1084"
          d="M 294.5 1379 L 295 1383.5 L 294 1383.5 L 294.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1085"
          d="M 981.5 1379 L 982.5 1381 L 981.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1086"
          d="M 1437.5 1379 L 1438 1382.5 L 1437 1382.5 L 1437.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1087"
          d="M 72.5 1380 L 73 1383.5 L 72 1383.5 L 72.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1088"
          d="M 1530.5 1380 L 1531 1383.5 L 1530 1383.5 L 1530.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1089"
          d="M 1751.5 1381 L 1752 1384.5 L 1751 1384.5 L 1751.5 1381 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1090"
          d="M 388.5 1382 L 389 1386.5 L 388 1386.5 L 388.5 1382 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1091"
          d="M 166.5 1386 L 167 1390.5 L 166 1390.5 L 166.5 1386 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1092"
          d="M 1658.5 1386 L 1659 1389.5 L 1658 1389.5 L 1658.5 1386 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1093"
          d="M 1438.5 1387 L 1439 1390.5 L 1438 1390.5 L 1438.5 1387 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1094"
          d="M 71.5 1388 L 72 1391.5 L 71 1391.5 L 71.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1095"
          d="M 293.5 1388 L 294 1391.5 L 293 1391.5 L 293.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1096"
          d="M 1531.5 1388 L 1532 1391.5 L 1531 1391.5 L 1531.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1097"
          d="M 1752.5 1389 L 1753 1392.5 L 1752 1392.5 L 1752.5 1389 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1098"
          d="M 387.5 1391 L 388 1394.5 L 387 1394.5 L 387.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1099"
          d="M 1019.5 1394 L 1022 1394.5 L 1019.5 1395 L 1019.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1100"
          d="M 165.5 1395 L 166 1398.5 L 165 1398.5 L 165.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1101"
          d="M 739.5 1395 L 742 1395.5 L 739.5 1396 L 739.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1102"
          d="M 803.5 1395 L 806 1395.5 L 803.5 1396 L 803.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1103"
          d="M 1024.5 1395 L 1027 1395.5 L 1024.5 1396 L 1024.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1104"
          d="M 1439.5 1395 L 1440 1398.5 L 1439 1398.5 L 1439.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1105"
          d="M 1659.5 1395 L 1660 1398.5 L 1659 1398.5 L 1659.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1106"
          d="M 70.5 1396 L 71 1400.5 L 70 1400.5 L 70.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1107"
          d="M 292.5 1396 L 293 1399.5 L 292 1399.5 L 292.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1108"
          d="M 745.5 1396 L 749 1396.5 L 745.5 1397 L 745.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1109"
          d="M 796.5 1396 L 800 1396.5 L 796.5 1397 L 796.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1110"
          d="M 1030.5 1396 L 1034 1396.5 L 1030.5 1397 L 1030.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1111"
          d="M 1081.5 1396 L 1084 1396.5 L 1081.5 1397 L 1081.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1112"
          d="M 1532.5 1396 L 1533 1399.5 L 1532 1399.5 L 1532.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1113"
          d="M 753.5 1397 L 759 1397.5 L 753.5 1398 L 753.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1114"
          d="M 786.5 1397 L 792 1397.5 L 786.5 1398 L 786.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1115"
          d="M 1038.5 1397 L 1044 1397.5 L 1038.5 1398 L 1038.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1116"
          d="M 1070.5 1397 L 1076 1397.5 L 1070.5 1398 L 1070.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1117"
          d="M 1753.5 1397 L 1754 1401.5 L 1753 1401.5 L 1753.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1118"
          d="M 386.5 1399 L 387 1402.5 L 386 1402.5 L 386.5 1399 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1119"
          d="M 164.5 1403 L 165 1406.5 L 164 1406.5 L 164.5 1403 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1120"
          d="M 1440.5 1403 L 1441 1406.5 L 1440 1406.5 L 1440.5 1403 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1121"
          d="M 1660.5 1403 L 1661 1406.5 L 1660 1406.5 L 1660.5 1403 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1122"
          d="M 291.5 1404 L 292 1407.5 L 291 1407.5 L 291.5 1404 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1123"
          d="M 69.5 1405 L 70 1408.5 L 69 1408.5 L 69.5 1405 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1124"
          d="M 1533.5 1405 L 1534 1408.5 L 1533 1408.5 L 1533.5 1405 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1125"
          d="M 1754.5 1406 L 1755 1409.5 L 1754 1409.5 L 1754.5 1406 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1126"
          d="M 385.5 1407 L 386 1410.5 L 385 1410.5 L 385.5 1407 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1127"
          d="M 163.5 1411 L 164 1415.5 L 163 1415.5 L 163.5 1411 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1128"
          d="M 1661.5 1411 L 1662 1414.5 L 1661 1414.5 L 1661.5 1411 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1129"
          d="M 290.5 1412 L 291 1415.5 L 290 1415.5 L 290.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1130"
          d="M 1441.5 1412 L 1442 1415.5 L 1441 1415.5 L 1441.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1131"
          d="M 68.5 1413 L 69 1416.5 L 68 1416.5 L 68.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1132"
          d="M 1534.5 1413 L 1535 1416.5 L 1534 1416.5 L 1534.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1133"
          d="M 1755.5 1414 L 1756 1417.5 L 1755 1417.5 L 1755.5 1414 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1134"
          d="M 384.5 1415 L 385 1418.5 L 384 1418.5 L 384.5 1415 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1135"
          d="M 1662.5 1419 L 1663 1423.5 L 1662 1423.5 L 1662.5 1419 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1136"
          d="M 162.5 1420 L 163 1423.5 L 162 1423.5 L 162.5 1420 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1137"
          d="M 1442.5 1420 L 1443 1423.5 L 1442 1423.5 L 1442.5 1420 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1138"
          d="M 67.5 1421 L 68 1425.5 L 67 1425.5 L 67.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1139"
          d="M 289.5 1421 L 290 1424.5 L 289 1424.5 L 289.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1140"
          d="M 1535.5 1421 L 1536 1424.5 L 1535 1424.5 L 1535.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1141"
          d="M 383.5 1423 L 384 1427.5 L 383 1427.5 L 383.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1142"
          d="M 1756.5 1423 L 1757 1426.5 L 1756 1426.5 L 1756.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1143"
          d="M 161.5 1428 L 162 1431.5 L 161 1431.5 L 161.5 1428 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1144"
          d="M 1443.5 1428 L 1444 1431.5 L 1443 1431.5 L 1443.5 1428 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1145"
          d="M 1663.5 1428 L 1664 1431.5 L 1663 1431.5 L 1663.5 1428 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1146"
          d="M 288.5 1429 L 289 1432.5 L 288 1432.5 L 288.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1147"
          d="M 1536.5 1429 L 1537 1432.5 L 1536 1432.5 L 1536.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1148"
          d="M 66.5 1430 L 67 1433.5 L 66 1433.5 L 66.5 1430 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1149"
          d="M 1757.5 1431 L 1758 1434.5 L 1757 1434.5 L 1757.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1150"
          d="M 382.5 1432 L 383 1435.5 L 382 1435.5 L 382.5 1432 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1151"
          d="M 160.5 1436 L 161 1440.5 L 160 1440.5 L 160.5 1436 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1152"
          d="M 1444.5 1436 L 1445 1439.5 L 1444 1439.5 L 1444.5 1436 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1153"
          d="M 1664.5 1436 L 1665 1439.5 L 1664 1439.5 L 1664.5 1436 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1154"
          d="M 287.5 1437 L 288 1440.5 L 287 1440.5 L 287.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1155"
          d="M 1537.5 1437 L 1538 1440.5 L 1537 1440.5 L 1537.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1156"
          d="M 65.5 1438 L 66 1441.5 L 65 1441.5 L 65.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1157"
          d="M 1758.5 1439 L 1759 1443.5 L 1758 1443.5 L 1758.5 1439 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1158"
          d="M 381.5 1440 L 382 1443.5 L 381 1443.5 L 381.5 1440 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1159"
          d="M 1445.5 1444 L 1446 1447.5 L 1445 1447.5 L 1445.5 1444 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1160"
          d="M 1665.5 1444 L 1666 1447.5 L 1665 1447.5 L 1665.5 1444 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1161"
          d="M 159.5 1445 L 160 1448.5 L 159 1448.5 L 159.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1162"
          d="M 286.5 1445 L 287 1448.5 L 286 1448.5 L 286.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1163"
          d="M 1538.5 1445 L 1539 1448.5 L 1538 1448.5 L 1538.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1164"
          d="M 64.5 1446 L 65 1450.5 L 64 1450.5 L 64.5 1446 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1165"
          d="M 380.5 1448 L 381 1451.5 L 380 1451.5 L 380.5 1448 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1166"
          d="M 1759.5 1448 L 1760 1451.5 L 1759 1451.5 L 1759.5 1448 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1167"
          d="M 158.5 1453 L 159 1456.5 L 158 1456.5 L 158.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1168"
          d="M 285.5 1453 L 286 1457.5 L 285 1457.5 L 285.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1169"
          d="M 1446.5 1453 L 1447 1456.5 L 1446 1456.5 L 1446.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1170"
          d="M 1666.5 1453 L 1667 1456.5 L 1666 1456.5 L 1666.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1171"
          d="M 1539.5 1454 L 1540 1457.5 L 1539 1457.5 L 1539.5 1454 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1172"
          d="M 63.5 1455 L 64 1458.5 L 63 1458.5 L 63.5 1455 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1173"
          d="M 379.5 1456 L 380 1459.5 L 379 1459.5 L 379.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1174"
          d="M 1760.5 1456 L 1761 1459.5 L 1760 1459.5 L 1760.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1175"
          d="M 157.5 1461 L 158 1464.5 L 157 1464.5 L 157.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1176"
          d="M 1447.5 1461 L 1448 1464.5 L 1447 1464.5 L 1447.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1177"
          d="M 1667.5 1461 L 1668 1464.5 L 1667 1464.5 L 1667.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1178"
          d="M 284.5 1462 L 285 1465.5 L 284 1465.5 L 284.5 1462 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1179"
          d="M 1540.5 1462 L 1541 1465.5 L 1540 1465.5 L 1540.5 1462 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1180"
          d="M 62.5 1463 L 63 1466.5 L 62 1466.5 L 62.5 1463 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1181"
          d="M 378.5 1464 L 379 1468.5 L 378 1468.5 L 378.5 1464 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1182"
          d="M 1761.5 1465 L 1762 1468.5 L 1761 1468.5 L 1761.5 1465 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1183"
          d="M 1448.5 1469 L 1449 1472.5 L 1448 1472.5 L 1448.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1184"
          d="M 1668.5 1469 L 1669 1472.5 L 1668 1472.5 L 1668.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1185"
          d="M 156.5 1470 L 157 1473.5 L 156 1473.5 L 156.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1186"
          d="M 283.5 1470 L 284 1473.5 L 283 1473.5 L 283.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1187"
          d="M 1541.5 1470 L 1542 1473.5 L 1541 1473.5 L 1541.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1188"
          d="M 61.5 1471 L 62 1475.5 L 61 1475.5 L 61.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1189"
          d="M 377.5 1473 L 378 1476.5 L 377 1476.5 L 377.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1190"
          d="M 1762.5 1473 L 1763 1476.5 L 1762 1476.5 L 1762.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1191"
          d="M 1449.5 1477 L 1450 1480.5 L 1449 1480.5 L 1449.5 1477 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1192"
          d="M 1669.5 1477 L 1670 1481.5 L 1669 1481.5 L 1669.5 1477 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1193"
          d="M 155.5 1478 L 156 1481.5 L 155 1481.5 L 155.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1194"
          d="M 282.5 1478 L 283 1481.5 L 282 1481.5 L 282.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1195"
          d="M 1542.5 1478 L 1543 1481.5 L 1542 1481.5 L 1542.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1196"
          d="M 60.5 1480 L 61 1483.5 L 60 1483.5 L 60.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1197"
          d="M 376.5 1481 L 377 1484.5 L 376 1484.5 L 376.5 1481 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1198"
          d="M 1763.5 1481 L 1764 1485.5 L 1763 1485.5 L 1763.5 1481 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1199"
          d="M 1450.5 1485 L 1451 1488.5 L 1450 1488.5 L 1450.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1200"
          d="M 154.5 1486 L 155 1489.5 L 154 1489.5 L 154.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1201"
          d="M 281.5 1486 L 282 1489.5 L 281 1489.5 L 281.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1202"
          d="M 1543.5 1486 L 1544 1489.5 L 1543 1489.5 L 1543.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1203"
          d="M 1670.5 1486 L 1671 1489.5 L 1670 1489.5 L 1670.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1204"
          d="M 59.5 1488 L 60 1491.5 L 59 1491.5 L 59.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1205"
          d="M 375.5 1489 L 376 1492.5 L 375 1492.5 L 375.5 1489 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1206"
          d="M 1764.5 1490 L 1765 1493.5 L 1764 1493.5 L 1764.5 1490 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1207"
          d="M 1451.5 1494 L 1452 1497.5 L 1451 1497.5 L 1451.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1208"
          d="M 1544.5 1494 L 1545 1497.5 L 1544 1497.5 L 1544.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1209"
          d="M 1671.5 1494 L 1672 1497.5 L 1671 1497.5 L 1671.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1210"
          d="M 153.5 1495 L 154 1498.5 L 153 1498.5 L 153.5 1495 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1211"
          d="M 280.5 1495 L 281 1498.5 L 280 1498.5 L 280.5 1495 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1212"
          d="M 58.5 1496 L 59 1499.5 L 58 1499.5 L 58.5 1496 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1213"
          d="M 374.5 1497 L 375 1500.5 L 374 1500.5 L 374.5 1497 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1214"
          d="M 1765.5 1498 L 1766 1501.5 L 1765 1501.5 L 1765.5 1498 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1215"
          d="M 1452.5 1502 L 1453 1505.5 L 1452 1505.5 L 1452.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1216"
          d="M 1545.5 1502 L 1546 1506.5 L 1545 1506.5 L 1545.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1217"
          d="M 1672.5 1502 L 1673 1505.5 L 1672 1505.5 L 1672.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1218"
          d="M 152.5 1503 L 153 1506.5 L 152 1506.5 L 152.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1219"
          d="M 279.5 1503 L 280 1506.5 L 279 1506.5 L 279.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1220"
          d="M 57.5 1505 L 58 1508.5 L 57 1508.5 L 57.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1221"
          d="M 373.5 1505 L 374 1509.5 L 373 1509.5 L 373.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1222"
          d="M 625.5 1505 L 640 1505.5 L 625.5 1506 L 625.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1223"
          d="M 905.5 1505 L 925 1505.5 L 905.5 1506 L 905.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1224"
          d="M 1189.5 1505 L 1204 1505.5 L 1189.5 1506 L 1189.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1225"
          d="M 619.5 1506 L 622 1506.5 L 619.5 1507 L 619.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1226"
          d="M 647.5 1506 L 652 1506.5 L 647.5 1507 L 647.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1227"
          d="M 893.5 1506 L 897 1506.5 L 893.5 1507 L 893.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1228"
          d="M 932.5 1506 L 937 1506.5 L 932.5 1507 L 932.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1229"
          d="M 1177.5 1506 L 1182 1506.5 L 1177.5 1507 L 1177.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1230"
          d="M 656.5 1507 L 659 1507.5 L 656.5 1508 L 656.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1231"
          d="M 886.5 1507 L 889 1507.5 L 886.5 1508 L 886.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1232"
          d="M 941.5 1507 L 944 1507.5 L 941.5 1508 L 941.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1233"
          d="M 1170.5 1507 L 1174 1507.5 L 1170.5 1508 L 1170.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1234"
          d="M 1766.5 1507 L 1767 1510.5 L 1766 1510.5 L 1766.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1235"
          d="M 662.5 1508 L 665 1508.5 L 662.5 1509 L 662.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1236"
          d="M 880.5 1508 L 883 1508.5 L 880.5 1509 L 880.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1237"
          d="M 947.5 1508 L 950 1508.5 L 947.5 1509 L 947.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1238"
          d="M 875.5 1509 L 878 1509.5 L 875.5 1510 L 875.5 1509 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1239"
          d="M 608.5 1510 L 607.5 1512 L 608.5 1510 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1240"
          d="M 1453.5 1510 L 1454 1513.5 L 1453 1513.5 L 1453.5 1510 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1241"
          d="M 151.5 1511 L 152 1514.5 L 151 1514.5 L 151.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1242"
          d="M 278.5 1511 L 279 1514.5 L 278 1514.5 L 278.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1243"
          d="M 1546.5 1511 L 1547 1514.5 L 1546 1514.5 L 1546.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1244"
          d="M 1673.5 1511 L 1674 1514.5 L 1673 1514.5 L 1673.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1245"
          d="M 1224.5 1512 L 1225.5 1514 L 1224.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1246"
          d="M 56.5 1513 L 57 1516.5 L 56 1516.5 L 56.5 1513 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1247"
          d="M 372.5 1514 L 373 1517.5 L 372 1517.5 L 372.5 1514 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1248"
          d="M 602.5 1514 L 601.5 1516 L 602.5 1514 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1249"
          d="M 1228.5 1515 L 1231.5 1519 L 1228.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1250"
          d="M 1767.5 1515 L 1768 1518.5 L 1767 1518.5 L 1767.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1251"
          d="M 598.5 1517 L 595.5 1521 L 598.5 1517 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1252"
          d="M 1454.5 1518 L 1455 1521.5 L 1454 1521.5 L 1454.5 1518 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1253"
          d="M 277.5 1519 L 278 1522.5 L 277 1522.5 L 277.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1254"
          d="M 1547.5 1519 L 1548 1522.5 L 1547 1522.5 L 1547.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1255"
          d="M 1674.5 1519 L 1675 1522.5 L 1674 1522.5 L 1674.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1256"
          d="M 150.5 1520 L 151 1523.5 L 150 1523.5 L 150.5 1520 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1257"
          d="M 1233.5 1520 L 1236.5 1524 L 1233.5 1520 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1258"
          d="M 55.5 1521 L 56 1524.5 L 55 1524.5 L 55.5 1521 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1259"
          d="M 371.5 1522 L 372 1525.5 L 371 1525.5 L 371.5 1522 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1260"
          d="M 593.5 1523 L 592.5 1525 L 593.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1261"
          d="M 839.5 1523 L 838.5 1525 L 839.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1262"
          d="M 1768.5 1523 L 1769 1527.5 L 1768 1527.5 L 1768.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1263"
          d="M 1122.5 1524 L 1121.5 1526 L 1122.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1264"
          d="M 710.5 1526 L 711.5 1528 L 710.5 1526 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1265"
          d="M 1455.5 1526 L 1456 1529.5 L 1455 1529.5 L 1455.5 1526 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1266"
          d="M 276.5 1527 L 277 1531.5 L 276 1531.5 L 276.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1267"
          d="M 1117.5 1527 L 1116.5 1529 L 1117.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1268"
          d="M 1548.5 1527 L 1549 1530.5 L 1548 1530.5 L 1548.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1269"
          d="M 1675.5 1527 L 1676 1530.5 L 1675 1530.5 L 1675.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1270"
          d="M 149.5 1528 L 150 1531.5 L 149 1531.5 L 149.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1271"
          d="M 998.5 1528 L 999.5 1530 L 998.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1272"
          d="M 589.5 1529 L 588.5 1531 L 589.5 1529 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1273"
          d="M 829.5 1529 L 828.5 1531 L 829.5 1529 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1274"
          d="M 54.5 1530 L 55 1533.5 L 54 1533.5 L 54.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1275"
          d="M 370.5 1530 L 371 1533.5 L 370 1533.5 L 370.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1276"
          d="M 718.5 1531 L 719.5 1533 L 718.5 1531 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1277"
          d="M 826.5 1531 L 825.5 1533 L 826.5 1531 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1278"
          d="M 1769.5 1532 L 1770 1535.5 L 1769 1535.5 L 1769.5 1532 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1279"
          d="M 721.5 1533 L 722.5 1535 L 721.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1280"
          d="M 823.5 1533 L 822.5 1535 L 823.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1281"
          d="M 724.5 1535 L 725.5 1537 L 724.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1282"
          d="M 820.5 1535 L 819.5 1537 L 820.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1283"
          d="M 1456.5 1535 L 1457 1538.5 L 1456 1538.5 L 1456.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1284"
          d="M 1549.5 1535 L 1550 1538.5 L 1549 1538.5 L 1549.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1285"
          d="M 1676.5 1535 L 1677 1539.5 L 1676 1539.5 L 1676.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1286"
          d="M 148.5 1536 L 149 1539.5 L 148 1539.5 L 148.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1287"
          d="M 275.5 1536 L 276 1539.5 L 275 1539.5 L 275.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1288"
          d="M 727.5 1537 L 728.5 1539 L 727.5 1537 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1289"
          d="M 817.5 1537 L 816.5 1539 L 817.5 1537 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1290"
          d="M 53.5 1538 L 54 1541.5 L 53 1541.5 L 53.5 1538 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1291"
          d="M 369.5 1538 L 370 1541.5 L 369 1541.5 L 369.5 1538 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1292"
          d="M 1013.5 1538 L 1014.5 1540 L 1013.5 1538 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1293"
          d="M 814.5 1539 L 813.5 1541 L 814.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1294"
          d="M 1099.5 1539 L 1098.5 1541 L 1099.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1295"
          d="M 1016.5 1540 L 1017.5 1542 L 1016.5 1540 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1296"
          d="M 1770.5 1540 L 1771 1543.5 L 1770 1543.5 L 1770.5 1540 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1297"
          d="M 1096.5 1541 L 1095.5 1543 L 1096.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1298"
          d="M 734.5 1542 L 735.5 1544 L 734.5 1542 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1299"
          d="M 1093.5 1543 L 1092.5 1545 L 1093.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1300"
          d="M 1457.5 1543 L 1458 1546.5 L 1457 1546.5 L 1457.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1301"
          d="M 1550.5 1543 L 1551 1546.5 L 1550 1546.5 L 1550.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1302"
          d="M 274.5 1544 L 275 1547.5 L 274 1547.5 L 274.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1303"
          d="M 737.5 1544 L 738.5 1546 L 737.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1304"
          d="M 1677.5 1544 L 1678 1547.5 L 1677 1547.5 L 1677.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1305"
          d="M 147.5 1545 L 148 1548.5 L 147 1548.5 L 147.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1306"
          d="M 1090.5 1545 L 1089.5 1547 L 1090.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1307"
          d="M 52.5 1546 L 53 1549.5 L 52 1549.5 L 52.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1308"
          d="M 368.5 1546 L 369 1550.5 L 368 1550.5 L 368.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1309"
          d="M 1025.5 1546 L 1026.5 1548 L 1025.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1310"
          d="M 583.5 1547 L 584 1557.5 L 583 1557.5 L 583.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1311"
          d="M 1771.5 1549 L 1772 1552.5 L 1771 1552.5 L 1771.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1312"
          d="M 1458.5 1551 L 1459 1554.5 L 1458 1554.5 L 1458.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1313"
          d="M 1551.5 1551 L 1552 1555.5 L 1551 1555.5 L 1551.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1314"
          d="M 273.5 1552 L 274 1555.5 L 273 1555.5 L 273.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1315"
          d="M 1678.5 1552 L 1679 1555.5 L 1678 1555.5 L 1678.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1316"
          d="M 146.5 1553 L 147 1556.5 L 146 1556.5 L 146.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1317"
          d="M 757.5 1553 L 760 1553.5 L 757.5 1554 L 757.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1318"
          d="M 785.5 1553 L 788 1553.5 L 785.5 1554 L 785.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1319"
          d="M 1042.5 1553 L 1045 1553.5 L 1042.5 1554 L 1042.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1320"
          d="M 765.5 1554 L 780 1554.5 L 765.5 1555 L 765.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1321"
          d="M 1049.5 1554 L 1065 1554.5 L 1049.5 1555 L 1049.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1322"
          d="M 51.5 1555 L 52 1558.5 L 51 1558.5 L 51.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1323"
          d="M 367.5 1555 L 368 1558.5 L 367 1558.5 L 367.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1324"
          d="M 1772.5 1557 L 1773 1560.5 L 1772 1560.5 L 1772.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1325"
          d="M 1245.5 1559 L 1246 1561.5 L 1245 1561.5 L 1245.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1326"
          d="M 1459.5 1559 L 1460 1562.5 L 1459 1562.5 L 1459.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1327"
          d="M 272.5 1560 L 273 1563.5 L 272 1563.5 L 272.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1328"
          d="M 1552.5 1560 L 1553 1563.5 L 1552 1563.5 L 1552.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1329"
          d="M 1679.5 1560 L 1680 1563.5 L 1679 1563.5 L 1679.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1330"
          d="M 145.5 1561 L 146 1564.5 L 145 1564.5 L 145.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1331"
          d="M 50.5 1563 L 51 1566.5 L 50 1566.5 L 50.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1332"
          d="M 366.5 1563 L 367 1566.5 L 366 1566.5 L 366.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1333"
          d="M 1773.5 1565 L 1774 1569.5 L 1773 1569.5 L 1773.5 1565 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1334"
          d="M 1460.5 1567 L 1461 1570.5 L 1460 1570.5 L 1460.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1335"
          d="M 1553.5 1568 L 1554 1571.5 L 1553 1571.5 L 1553.5 1568 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1336"
          d="M 144.5 1569 L 145 1573.5 L 144 1573.5 L 144.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1337"
          d="M 271.5 1569 L 272 1572.5 L 271 1572.5 L 271.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1338"
          d="M 1680.5 1569 L 1681 1572.5 L 1680 1572.5 L 1680.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1339"
          d="M 49.5 1571 L 50 1574.5 L 49 1574.5 L 49.5 1571 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1340"
          d="M 365.5 1571 L 366 1574.5 L 365 1574.5 L 365.5 1571 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1341"
          d="M 1774.5 1574 L 1775 1577.5 L 1774 1577.5 L 1774.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1342"
          d="M 1461.5 1576 L 1462 1579.5 L 1461 1579.5 L 1461.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1343"
          d="M 1554.5 1576 L 1555 1579.5 L 1554 1579.5 L 1554.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1344"
          d="M 270.5 1577 L 271 1580.5 L 270 1580.5 L 270.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1345"
          d="M 1681.5 1577 L 1682 1580.5 L 1681 1580.5 L 1681.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1346"
          d="M 143.5 1578 L 144 1581.5 L 143 1581.5 L 143.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1347"
          d="M 591.5 1578 L 592.5 1580 L 591.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1348"
          d="M 364.5 1579 L 365 1582.5 L 364 1582.5 L 364.5 1579 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1349"
          d="M 1237.5 1579 L 1236.5 1581 L 1237.5 1579 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1350"
          d="M 48.5 1580 L 49 1583.5 L 48 1583.5 L 48.5 1580 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1351"
          d="M 593.5 1581 L 600.5 1589 L 593.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1352"
          d="M 1775.5 1582 L 1776 1585.5 L 1775 1585.5 L 1775.5 1582 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1353"
          d="M 1234.5 1583 L 1231.5 1587 L 1234.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1354"
          d="M 1462.5 1584 L 1463 1587.5 L 1462 1587.5 L 1462.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1355"
          d="M 1555.5 1584 L 1556 1587.5 L 1555 1587.5 L 1555.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1356"
          d="M 269.5 1585 L 270 1588.5 L 269 1588.5 L 269.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1357"
          d="M 1682.5 1585 L 1683 1588.5 L 1682 1588.5 L 1682.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1358"
          d="M 142.5 1586 L 143 1589.5 L 142 1589.5 L 142.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1359"
          d="M 363.5 1587 L 364 1591.5 L 363 1591.5 L 363.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1360"
          d="M 47.5 1588 L 48 1591.5 L 47 1591.5 L 47.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1361"
          d="M 1227.5 1589 L 1226.5 1591 L 1227.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1362"
          d="M 1224.5 1591 L 1223.5 1593 L 1224.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1363"
          d="M 1776.5 1591 L 1777 1594.5 L 1776 1594.5 L 1776.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1364"
          d="M 1463.5 1592 L 1464 1595.5 L 1463 1595.5 L 1463.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1365"
          d="M 1556.5 1592 L 1557 1595.5 L 1556 1595.5 L 1556.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1366"
          d="M 268.5 1593 L 269 1596.5 L 268 1596.5 L 268.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1367"
          d="M 1683.5 1593 L 1684 1597.5 L 1683 1597.5 L 1683.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1368"
          d="M 141.5 1594 L 142 1598.5 L 141 1598.5 L 141.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1369"
          d="M 46.5 1596 L 47 1599.5 L 46 1599.5 L 46.5 1596 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1370"
          d="M 362.5 1596 L 363 1599.5 L 362 1599.5 L 362.5 1596 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1371"
          d="M 622.5 1598 L 627 1598.5 L 622.5 1599 L 622.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1372"
          d="M 1203.5 1598 L 1207 1598.5 L 1203.5 1599 L 1203.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1373"
          d="M 639.5 1599 L 643 1599.5 L 639.5 1600 L 639.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1374"
          d="M 902.5 1599 L 906 1599.5 L 902.5 1600 L 902.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1375"
          d="M 924.5 1599 L 928 1599.5 L 924.5 1600 L 924.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1376"
          d="M 1186.5 1599 L 1190 1599.5 L 1186.5 1600 L 1186.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1377"
          d="M 1777.5 1599 L 1778 1602.5 L 1777 1602.5 L 1777.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1378"
          d="M 1464.5 1600 L 1465 1603.5 L 1464 1603.5 L 1464.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1379"
          d="M 1557.5 1600 L 1558 1603.5 L 1557 1603.5 L 1557.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1380"
          d="M 267.5 1601 L 268 1605.5 L 267 1605.5 L 267.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1381"
          d="M 1684.5 1602 L 1685 1605.5 L 1684 1605.5 L 1684.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1382"
          d="M 140.5 1603 L 141 1606.5 L 140 1606.5 L 140.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1383"
          d="M 45.5 1604 L 46 1608.5 L 45 1608.5 L 45.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1384"
          d="M 361.5 1604 L 362 1607.5 L 361 1607.5 L 361.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1385"
          d="M 946.5 1606 L 947.5 1608 L 946.5 1606 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1386"
          d="M 881.5 1607 L 880.5 1609 L 881.5 1607 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1387"
          d="M 1778.5 1607 L 1779 1611.5 L 1778 1611.5 L 1778.5 1607 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1388"
          d="M 1465.5 1608 L 1466 1611.5 L 1465 1611.5 L 1465.5 1608 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1389"
          d="M 666.5 1609 L 667.5 1611 L 666.5 1609 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1390"
          d="M 878.5 1609 L 877.5 1611 L 878.5 1609 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1391"
          d="M 1558.5 1609 L 1559 1612.5 L 1558 1612.5 L 1558.5 1609 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1392"
          d="M 266.5 1610 L 267 1613.5 L 266 1613.5 L 266.5 1610 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1393"
          d="M 952.5 1610 L 953.5 1612 L 952.5 1610 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1394"
          d="M 1685.5 1610 L 1686 1613.5 L 1685 1613.5 L 1685.5 1610 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1395"
          d="M 139.5 1611 L 140 1614.5 L 139 1614.5 L 139.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1396"
          d="M 875.5 1611 L 874.5 1613 L 875.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1397"
          d="M 360.5 1612 L 361 1615.5 L 360 1615.5 L 360.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1398"
          d="M 955.5 1612 L 956.5 1614 L 955.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1399"
          d="M 44.5 1613 L 45 1616.5 L 44 1616.5 L 44.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1400"
          d="M 1157.5 1613 L 1156.5 1615 L 1157.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1401"
          d="M 673.5 1614 L 674.5 1616 L 673.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1402"
          d="M 871.5 1614 L 870.5 1616 L 871.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1403"
          d="M 1154.5 1615 L 1153.5 1617 L 1154.5 1615 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1404"
          d="M 676.5 1616 L 677.5 1618 L 676.5 1616 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1405"
          d="M 868.5 1616 L 867.5 1618 L 868.5 1616 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1406"
          d="M 1779.5 1616 L 1780 1619.5 L 1779 1619.5 L 1779.5 1616 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1407"
          d="M 1151.5 1617 L 1150.5 1619 L 1151.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1408"
          d="M 1466.5 1617 L 1467 1620.5 L 1466 1620.5 L 1466.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1409"
          d="M 1559.5 1617 L 1560 1620.5 L 1559 1620.5 L 1559.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1410"
          d="M 265.5 1618 L 266 1621.5 L 265 1621.5 L 265.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1411"
          d="M 679.5 1618 L 680.5 1620 L 679.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1412"
          d="M 865.5 1618 L 864.5 1620 L 865.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1413"
          d="M 1686.5 1618 L 1687 1621.5 L 1686 1621.5 L 1686.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1414"
          d="M 138.5 1619 L 139 1623.5 L 138 1623.5 L 138.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1415"
          d="M 1148.5 1619 L 1147.5 1621 L 1148.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1416"
          d="M 359.5 1620 L 360 1623.5 L 359 1623.5 L 359.5 1620 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1417"
          d="M 682.5 1620 L 683.5 1622 L 682.5 1620 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1418"
          d="M 862.5 1620 L 861.5 1622 L 862.5 1620 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1419"
          d="M 43.5 1621 L 44 1624.5 L 43 1624.5 L 43.5 1621 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1420"
          d="M 1145.5 1621 L 1144.5 1623 L 1145.5 1621 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1421"
          d="M 1142.5 1623 L 1141.5 1625 L 1142.5 1623 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1422"
          d="M 973.5 1624 L 974.5 1626 L 973.5 1624 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1423"
          d="M 1780.5 1624 L 1781 1627.5 L 1780 1627.5 L 1780.5 1624 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1424"
          d="M 690.5 1625 L 691.5 1627 L 690.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1425"
          d="M 854.5 1625 L 853.5 1627 L 854.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1426"
          d="M 1467.5 1625 L 1468 1628.5 L 1467 1628.5 L 1467.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1427"
          d="M 1560.5 1625 L 1561 1628.5 L 1560 1628.5 L 1560.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1428"
          d="M 264.5 1626 L 265 1629.5 L 264 1629.5 L 264.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1429"
          d="M 1137.5 1626 L 1136.5 1628 L 1137.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1430"
          d="M 978.5 1627 L 979.5 1629 L 978.5 1627 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1431"
          d="M 1687.5 1627 L 1688 1630.5 L 1687 1630.5 L 1687.5 1627 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1432"
          d="M 137.5 1628 L 138 1631.5 L 137 1631.5 L 137.5 1628 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1433"
          d="M 358.5 1628 L 359 1632.5 L 358 1632.5 L 358.5 1628 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1434"
          d="M 695.5 1628 L 696.5 1630 L 695.5 1628 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1435"
          d="M 42.5 1629 L 43 1633.5 L 42 1633.5 L 42.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1436"
          d="M 1130.5 1630 L 1129.5 1632 L 1130.5 1630 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1437"
          d="M 1468.5 1633 L 1469 1636.5 L 1468 1636.5 L 1468.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1438"
          d="M 1561.5 1633 L 1562 1636.5 L 1561 1636.5 L 1561.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1439"
          d="M 1781.5 1633 L 1782 1636.5 L 1781 1636.5 L 1781.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1440"
          d="M 263.5 1634 L 264 1637.5 L 263 1637.5 L 263.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1441"
          d="M 1688.5 1635 L 1689 1638.5 L 1688 1638.5 L 1688.5 1635 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1442"
          d="M 136.5 1636 L 137 1639.5 L 136 1639.5 L 136.5 1636 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1443"
          d="M 357.5 1637 L 358 1640.5 L 357 1640.5 L 357.5 1637 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1444"
          d="M 41.5 1638 L 42 1641.5 L 41 1641.5 L 41.5 1638 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1445"
          d="M 1469.5 1641 L 1470 1644.5 L 1469 1644.5 L 1469.5 1641 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1446"
          d="M 1562.5 1641 L 1563 1644.5 L 1562 1644.5 L 1562.5 1641 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1447"
          d="M 1782.5 1641 L 1783 1644.5 L 1782 1644.5 L 1782.5 1641 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1448"
          d="M 262.5 1643 L 263 1646.5 L 262 1646.5 L 262.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1449"
          d="M 1689.5 1643 L 1690 1646.5 L 1689 1646.5 L 1689.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1450"
          d="M 135.5 1644 L 136 1648.5 L 135 1648.5 L 135.5 1644 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1451"
          d="M 1091.5 1644 L 1094 1644.5 L 1091.5 1645 L 1091.5 1644 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1452"
          d="M 356.5 1645 L 357 1648.5 L 356 1648.5 L 356.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1453"
          d="M 741.5 1645 L 744 1645.5 L 741.5 1646 L 741.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1454"
          d="M 801.5 1645 L 804 1645.5 L 801.5 1646 L 801.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1455"
          d="M 1026.5 1645 L 1029 1645.5 L 1026.5 1646 L 1026.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1456"
          d="M 1086.5 1645 L 1089 1645.5 L 1086.5 1646 L 1086.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1457"
          d="M 40.5 1646 L 41 1649.5 L 40 1649.5 L 40.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1458"
          d="M 747.5 1646 L 751 1646.5 L 747.5 1647 L 747.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1459"
          d="M 794.5 1646 L 798 1646.5 L 794.5 1647 L 794.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1460"
          d="M 1032.5 1646 L 1036 1646.5 L 1032.5 1647 L 1032.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1461"
          d="M 1078.5 1646 L 1082 1646.5 L 1078.5 1647 L 1078.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1462"
          d="M 757.5 1647 L 765 1647.5 L 757.5 1648 L 757.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1463"
          d="M 780.5 1647 L 788 1647.5 L 780.5 1648 L 780.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1464"
          d="M 1041.5 1647 L 1050 1647.5 L 1041.5 1648 L 1041.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1465"
          d="M 1064.5 1647 L 1073 1647.5 L 1064.5 1648 L 1064.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1466"
          d="M 1470.5 1649 L 1471 1652.5 L 1470 1652.5 L 1470.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1467"
          d="M 1563.5 1649 L 1564 1652.5 L 1563 1652.5 L 1563.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1468"
          d="M 1783.5 1649 L 1784 1653.5 L 1783 1653.5 L 1783.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1469"
          d="M 261.5 1651 L 262 1654.5 L 261 1654.5 L 261.5 1651 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1470"
          d="M 1690.5 1652 L 1691 1655.5 L 1690 1655.5 L 1690.5 1652 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1471"
          d="M 134.5 1653 L 135 1656.5 L 134 1656.5 L 134.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1472"
          d="M 355.5 1653 L 356 1656.5 L 355 1656.5 L 355.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1473"
          d="M 39.5 1654 L 40 1658.5 L 39 1658.5 L 39.5 1654 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1474"
          d="M 1471.5 1658 L 1472 1661.5 L 1471 1661.5 L 1471.5 1658 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1475"
          d="M 1564.5 1658 L 1565 1661.5 L 1564 1661.5 L 1564.5 1658 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1476"
          d="M 1784.5 1658 L 1785 1661.5 L 1784 1661.5 L 1784.5 1658 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1477"
          d="M 260.5 1659 L 261 1662.5 L 260 1662.5 L 260.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1478"
          d="M 1691.5 1660 L 1692 1663.5 L 1691 1663.5 L 1691.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1479"
          d="M 133.5 1661 L 134 1664.5 L 133 1664.5 L 133.5 1661 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1480"
          d="M 354.5 1661 L 355 1664.5 L 354 1664.5 L 354.5 1661 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1481"
          d="M 38.5 1663 L 39 1666.5 L 38 1666.5 L 38.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1482"
          d="M 1472.5 1666 L 1473 1669.5 L 1472 1669.5 L 1472.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1483"
          d="M 1565.5 1666 L 1566 1669.5 L 1565 1669.5 L 1565.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1484"
          d="M 1785.5 1666 L 1786 1669.5 L 1785 1669.5 L 1785.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1485"
          d="M 259.5 1667 L 260 1670.5 L 259 1670.5 L 259.5 1667 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1486"
          d="M 1692.5 1668 L 1693 1671.5 L 1692 1671.5 L 1692.5 1668 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1487"
          d="M 132.5 1669 L 133 1672.5 L 132 1672.5 L 132.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1488"
          d="M 353.5 1669 L 354 1673.5 L 353 1673.5 L 353.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1489"
          d="M 37.5 1671 L 38 1674.5 L 37 1674.5 L 37.5 1671 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1490"
          d="M 1473.5 1674 L 1474 1677.5 L 1473 1677.5 L 1473.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1491"
          d="M 1566.5 1674 L 1567 1677.5 L 1566 1677.5 L 1566.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1492"
          d="M 258.5 1675 L 259 1679.5 L 258 1679.5 L 258.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1493"
          d="M 1786.5 1675 L 1787 1678.5 L 1786 1678.5 L 1786.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1494"
          d="M 1693.5 1676 L 1694 1680.5 L 1693 1680.5 L 1693.5 1676 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1495"
          d="M 131.5 1678 L 132 1681.5 L 131 1681.5 L 131.5 1678 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1496"
          d="M 352.5 1678 L 353 1681.5 L 352 1681.5 L 352.5 1678 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1497"
          d="M 36.5 1679 L 37 1683.5 L 36 1683.5 L 36.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1498"
          d="M 1474.5 1682 L 1475 1685.5 L 1474 1685.5 L 1474.5 1682 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1499"
          d="M 1567.5 1682 L 1568 1685.5 L 1567 1685.5 L 1567.5 1682 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1500"
          d="M 1787.5 1683 L 1788 1686.5 L 1787 1686.5 L 1787.5 1683 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1501"
          d="M 257.5 1684 L 258 1687.5 L 257 1687.5 L 257.5 1684 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1502"
          d="M 1694.5 1685 L 1695 1688.5 L 1694 1688.5 L 1694.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1503"
          d="M 130.5 1686 L 131 1689.5 L 130 1689.5 L 130.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1504"
          d="M 351.5 1686 L 352 1689.5 L 351 1689.5 L 351.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1505"
          d="M 35.5 1688 L 36 1691.5 L 35 1691.5 L 35.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1506"
          d="M 1475.5 1690 L 1476 1693.5 L 1475 1693.5 L 1475.5 1690 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1507"
          d="M 1568.5 1690 L 1569 1693.5 L 1568 1693.5 L 1568.5 1690 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1508"
          d="M 1788.5 1691 L 1789 1695.5 L 1788 1695.5 L 1788.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1509"
          d="M 256.5 1692 L 257 1695.5 L 256 1695.5 L 256.5 1692 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1510"
          d="M 1695.5 1693 L 1696 1696.5 L 1695 1696.5 L 1695.5 1693 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1511"
          d="M 129.5 1694 L 130 1697.5 L 129 1697.5 L 129.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1512"
          d="M 350.5 1694 L 351 1697.5 L 350 1697.5 L 350.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1513"
          d="M 34.5 1696 L 35 1699.5 L 34 1699.5 L 34.5 1696 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1514"
          d="M 1569.5 1698 L 1570 1701.5 L 1569 1701.5 L 1569.5 1698 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1515"
          d="M 1476.5 1699 L 1477 1702.5 L 1476 1702.5 L 1476.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1516"
          d="M 255.5 1700 L 256 1703.5 L 255 1703.5 L 255.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1517"
          d="M 1789.5 1700 L 1790 1703.5 L 1789 1703.5 L 1789.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1518"
          d="M 1696.5 1701 L 1697 1704.5 L 1696 1704.5 L 1696.5 1701 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1519"
          d="M 349.5 1702 L 350 1705.5 L 349 1705.5 L 349.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1520"
          d="M 128.5 1703 L 129 1706.5 L 128 1706.5 L 128.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1521"
          d="M 33.5 1704 L 34 1707.5 L 33 1707.5 L 33.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1522"
          d="M 1570.5 1706 L 1571 1710.5 L 1570 1710.5 L 1570.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1523"
          d="M 1477.5 1707 L 1478 1710.5 L 1477 1710.5 L 1477.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1524"
          d="M 254.5 1708 L 255 1711.5 L 254 1711.5 L 254.5 1708 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1525"
          d="M 1790.5 1708 L 1791 1711.5 L 1790 1711.5 L 1790.5 1708 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1526"
          d="M 348.5 1710 L 349 1714.5 L 348 1714.5 L 348.5 1710 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1527"
          d="M 1697.5 1710 L 1698 1713.5 L 1697 1713.5 L 1697.5 1710 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1528"
          d="M 127.5 1711 L 128 1714.5 L 127 1714.5 L 127.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1529"
          d="M 32.5 1713 L 33 1716.5 L 32 1716.5 L 32.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1530"
          d="M 1478.5 1715 L 1479 1718.5 L 1478 1718.5 L 1478.5 1715 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1531"
          d="M 1571.5 1715 L 1572 1718.5 L 1571 1718.5 L 1571.5 1715 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1532"
          d="M 253.5 1717 L 254 1720.5 L 253 1720.5 L 253.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1533"
          d="M 1791.5 1717 L 1792 1720.5 L 1791 1720.5 L 1791.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1534"
          d="M 1698.5 1718 L 1699 1721.5 L 1698 1721.5 L 1698.5 1718 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1535"
          d="M 126.5 1719 L 127 1722.5 L 126 1722.5 L 126.5 1719 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1536"
          d="M 347.5 1719 L 348 1722.5 L 347 1722.5 L 347.5 1719 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1537"
          d="M 31.5 1721 L 32 1724.5 L 31 1724.5 L 31.5 1721 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1538"
          d="M 1479.5 1723 L 1480 1726.5 L 1479 1726.5 L 1479.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1539"
          d="M 1572.5 1723 L 1573 1726.5 L 1572 1726.5 L 1572.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1540"
          d="M 252.5 1725 L 253 1728.5 L 252 1728.5 L 252.5 1725 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1541"
          d="M 1792.5 1725 L 1793 1728.5 L 1792 1728.5 L 1792.5 1725 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1542"
          d="M 1699.5 1726 L 1700 1729.5 L 1699 1729.5 L 1699.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1543"
          d="M 346.5 1727 L 347 1730.5 L 346 1730.5 L 346.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1544"
          d="M 125.5 1728 L 126 1731.5 L 125 1731.5 L 125.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1545"
          d="M 30.5 1729 L 31 1732.5 L 30 1732.5 L 30.5 1729 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1546"
          d="M 1480.5 1731 L 1481 1734.5 L 1480 1734.5 L 1480.5 1731 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1547"
          d="M 1573.5 1731 L 1574 1734.5 L 1573 1734.5 L 1573.5 1731 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1548"
          d="M 251.5 1733 L 252 1736.5 L 251 1736.5 L 251.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1549"
          d="M 1793.5 1733 L 1794 1737.5 L 1793 1737.5 L 1793.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1550"
          d="M 1700.5 1734 L 1701 1738.5 L 1700 1738.5 L 1700.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1551"
          d="M 345.5 1735 L 346 1738.5 L 345 1738.5 L 345.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1552"
          d="M 124.5 1736 L 125 1739.5 L 124 1739.5 L 124.5 1736 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1553"
          d="M 29.5 1738 L 30 1741.5 L 29 1741.5 L 29.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1554"
          d="M 1574.5 1739 L 1575 1742.5 L 1574 1742.5 L 1574.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1555"
          d="M 1481.5 1740 L 1482 1743.5 L 1481 1743.5 L 1481.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1556"
          d="M 250.5 1741 L 251 1744.5 L 250 1744.5 L 250.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1557"
          d="M 1794.5 1742 L 1795 1745.5 L 1794 1745.5 L 1794.5 1742 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1558"
          d="M 344.5 1743 L 345 1746.5 L 344 1746.5 L 344.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1559"
          d="M 1701.5 1743 L 1702 1746.5 L 1701 1746.5 L 1701.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1560"
          d="M 123.5 1744 L 124 1747.5 L 123 1747.5 L 123.5 1744 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1561"
          d="M 28.5 1746 L 29 1749.5 L 28 1749.5 L 28.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1562"
          d="M 1575.5 1747 L 1576 1750.5 L 1575 1750.5 L 1575.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1563"
          d="M 1482.5 1748 L 1483 1751.5 L 1482 1751.5 L 1482.5 1748 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1564"
          d="M 249.5 1749 L 250 1753.5 L 249 1753.5 L 249.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1565"
          d="M 1795.5 1750 L 1796 1753.5 L 1795 1753.5 L 1795.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1566"
          d="M 343.5 1751 L 344 1755.5 L 343 1755.5 L 343.5 1751 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1567"
          d="M 1702.5 1751 L 1703 1754.5 L 1702 1754.5 L 1702.5 1751 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1568"
          d="M 122.5 1753 L 123 1756.5 L 122 1756.5 L 122.5 1753 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1569"
          d="M 27.5 1754 L 28 1757.5 L 27 1757.5 L 27.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1570"
          d="M 1576.5 1755 L 1577 1759.5 L 1576 1759.5 L 1576.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1571"
          d="M 1483.5 1756 L 1484 1759.5 L 1483 1759.5 L 1483.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1572"
          d="M 248.5 1758 L 249 1761.5 L 248 1761.5 L 248.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1573"
          d="M 1703.5 1759 L 1704 1762.5 L 1703 1762.5 L 1703.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1574"
          d="M 1796.5 1759 L 1797 1762.5 L 1796 1762.5 L 1796.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1575"
          d="M 342.5 1760 L 343 1763.5 L 342 1763.5 L 342.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1576"
          d="M 121.5 1761 L 122 1764.5 L 121 1764.5 L 121.5 1761 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1577"
          d="M 26.5 1763 L 27 1766.5 L 26 1766.5 L 26.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1578"
          d="M 1484.5 1764 L 1485 1767.5 L 1484 1767.5 L 1484.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1579"
          d="M 1577.5 1764 L 1578 1767.5 L 1577 1767.5 L 1577.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1580"
          d="M 247.5 1766 L 248 1769.5 L 247 1769.5 L 247.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1581"
          d="M 1797.5 1767 L 1798 1770.5 L 1797 1770.5 L 1797.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1582"
          d="M 341.5 1768 L 342 1771.5 L 341 1771.5 L 341.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1583"
          d="M 1704.5 1768 L 1705 1771.5 L 1704 1771.5 L 1704.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1584"
          d="M 120.5 1769 L 121 1772.5 L 120 1772.5 L 120.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1585"
          d="M 25.5 1771 L 26 1774.5 L 25 1774.5 L 25.5 1771 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1586"
          d="M 1485.5 1772 L 1486 1775.5 L 1485 1775.5 L 1485.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1587"
          d="M 1578.5 1772 L 1579 1775.5 L 1578 1775.5 L 1578.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1588"
          d="M 246.5 1774 L 247 1777.5 L 246 1777.5 L 246.5 1774 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1589"
          d="M 1798.5 1775 L 1799 1779.5 L 1798 1779.5 L 1798.5 1775 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1590"
          d="M 340.5 1776 L 341 1779.5 L 340 1779.5 L 340.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1591"
          d="M 1705.5 1776 L 1706 1779.5 L 1705 1779.5 L 1705.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1592"
          d="M 119.5 1777 L 120 1781.5 L 119 1781.5 L 119.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1593"
          d="M 24.5 1779 L 25 1782.5 L 24 1782.5 L 24.5 1779 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1594"
          d="M 1579.5 1780 L 1580 1783.5 L 1579 1783.5 L 1579.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1595"
          d="M 1486.5 1781 L 1487 1784.5 L 1486 1784.5 L 1486.5 1781 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1596"
          d="M 245.5 1782 L 246 1785.5 L 245 1785.5 L 245.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1597"
          d="M 339.5 1784 L 340 1787.5 L 339 1787.5 L 339.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1598"
          d="M 1706.5 1784 L 1707 1787.5 L 1706 1787.5 L 1706.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1599"
          d="M 1799.5 1784 L 1800 1787.5 L 1799 1787.5 L 1799.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1600"
          d="M 118.5 1786 L 119 1789.5 L 118 1789.5 L 118.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1601"
          d="M 23.5 1788 L 24 1791.5 L 23 1791.5 L 23.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1602"
          d="M 1487.5 1789 L 1488 1792.5 L 1487 1792.5 L 1487.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1603"
          d="M 1580.5 1789 L 1581 1798.5 L 1580 1798.5 L 1580.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1604"
          d="M 244.5 1791 L 245 1800.5 L 244 1800.5 L 244.5 1791 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1605"
          d="M 338.5 1792 L 339 1796.5 L 338 1796.5 L 338.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1606"
          d="M 1707.5 1792 L 1708 1796.5 L 1707 1796.5 L 1707.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1607"
          d="M 1800.5 1792 L 1801 1795.5 L 1800 1795.5 L 1800.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1608"
          d="M 117.5 1794 L 118 1797.5 L 117 1797.5 L 117.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1609"
          d="M 22.5 1796 L 23 1799.5 L 22 1799.5 L 22.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1610"
          d="M 1488.5 1797 L 1489 1800.5 L 1488 1800.5 L 1488.5 1797 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1611"
          d="M 1708.5 1801 L 1709 1804.5 L 1708 1804.5 L 1708.5 1801 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1612"
          d="M 1801.5 1801 L 1802 1804.5 L 1801 1804.5 L 1801.5 1801 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1613"
          d="M 116.5 1802 L 117 1806.5 L 116 1806.5 L 116.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1614"
          d="M 21.5 1804 L 22 1807.5 L 21 1807.5 L 21.5 1804 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1615"
          d="M 1489.5 1806 L 1490 1810.5 L 1489 1810.5 L 1489.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1616"
          d="M 1580.5 1807 L 1581 1816.5 L 1580 1816.5 L 1580.5 1807 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1617"
          d="M 244.5 1809 L 245 1818.5 L 244 1818.5 L 244.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1618"
          d="M 1709.5 1809 L 1710 1812.5 L 1709 1812.5 L 1709.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1619"
          d="M 1802.5 1809 L 1803 1812.5 L 1802 1812.5 L 1802.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1620"
          d="M 115.5 1811 L 116 1814.5 L 115 1814.5 L 115.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1621"
          d="M 20.5 1812 L 21 1816.5 L 20 1816.5 L 20.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1622"
          d="M 338.5 1812 L 339 1814.5 L 338 1814.5 L 338.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1623"
          d="M 1488.5 1816 L 1489 1818.5 L 1488 1818.5 L 1488.5 1816 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1624"
          d="M 1710.5 1817 L 1711 1820.5 L 1710 1820.5 L 1710.5 1817 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1625"
          d="M 1803.5 1817 L 1804 1821.5 L 1803 1821.5 L 1803.5 1817 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1626"
          d="M 114.5 1819 L 115 1822.5 L 114 1822.5 L 114.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1627"
          d="M 19.5 1821 L 20 1824.5 L 19 1824.5 L 19.5 1821 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1628"
          d="M 1579.5 1822 L 1580 1825.5 L 1579 1825.5 L 1579.5 1822 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1629"
          d="M 245.5 1824 L 246 1827.5 L 245 1827.5 L 245.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1630"
          d="M 1711.5 1826 L 1712 1829.5 L 1711 1829.5 L 1711.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1631"
          d="M 1804.5 1826 L 1805 1829.5 L 1804 1829.5 L 1804.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1632"
          d="M 113.5 1827 L 114 1831.5 L 113 1831.5 L 113.5 1827 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1633"
          d="M 18.5 1829 L 19 1832.5 L 18 1832.5 L 18.5 1829 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1634"
          d="M 1578.5 1829 L 1579 1831.5 L 1578 1831.5 L 1578.5 1829 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1635"
          d="M 246.5 1831 L 247 1833.5 L 246 1833.5 L 246.5 1831 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1636"
          d="M 1482.5 1834 L 1481.5 1836 L 1482.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1637"
          d="M 1712.5 1834 L 1713 1837.5 L 1712 1837.5 L 1712.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1638"
          d="M 1805.5 1834 L 1806 1837.5 L 1805 1837.5 L 1805.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1639"
          d="M 112.5 1836 L 113 1839.5 L 112 1839.5 L 112.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1640"
          d="M 247.5 1836 L 248 1838.5 L 247 1838.5 L 247.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1641"
          d="M 17.5 1837 L 18 1841.5 L 17 1841.5 L 17.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1642"
          d="M 349.5 1839 L 350.5 1841 L 349.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1643"
          d="M 1479.5 1839 L 1478.5 1841 L 1479.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1644"
          d="M 1713.5 1842 L 1714 1845.5 L 1713 1845.5 L 1713.5 1842 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1645"
          d="M 352.5 1843 L 354.5 1846 L 352.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1646"
          d="M 1476.5 1843 L 1475.5 1845 L 1476.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1647"
          d="M 1806.5 1843 L 1807 1846.5 L 1806 1846.5 L 1806.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1648"
          d="M 111.5 1844 L 112 1847.5 L 111 1847.5 L 111.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1649"
          d="M 16.5 1846 L 17 1849.5 L 16 1849.5 L 16.5 1846 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1650"
          d="M 1473.5 1847 L 1467.5 1854 L 1473.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1651"
          d="M 1714.5 1850 L 1715 1854.5 L 1714 1854.5 L 1714.5 1850 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1652"
          d="M 1807.5 1851 L 1808 1854.5 L 1807 1854.5 L 1807.5 1851 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1653"
          d="M 110.5 1852 L 111 1855.5 L 110 1855.5 L 110.5 1852 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1654"
          d="M 361.5 1852 L 362.5 1854 L 361.5 1852 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1655"
          d="M 15.5 1854 L 16 1857.5 L 15 1857.5 L 15.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1656"
          d="M 1465.5 1854 L 1464.5 1856 L 1465.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1657"
          d="M 1715.5 1859 L 1716 1862.5 L 1715 1862.5 L 1715.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1658"
          d="M 1808.5 1859 L 1809 1862.5 L 1808 1862.5 L 1808.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1659"
          d="M 109.5 1861 L 110 1864.5 L 109 1864.5 L 109.5 1861 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1660"
          d="M 14.5 1862 L 15 1866.5 L 14 1866.5 L 14.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1661"
          d="M 1444.5 1862 L 1447 1862.5 L 1444.5 1863 L 1444.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1662"
          d="M 385.5 1863 L 388 1863.5 L 385.5 1864 L 385.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1663"
          d="M 1438.5 1863 L 1442 1863.5 L 1438.5 1864 L 1438.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1664"
          d="M 392.5 1864 L 399 1864.5 L 392.5 1865 L 392.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1665"
          d="M 1426.5 1864 L 1434 1864.5 L 1426.5 1865 L 1426.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1666"
          d="M 1716.5 1867 L 1717 1870.5 L 1716 1870.5 L 1716.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1667"
          d="M 1809.5 1868 L 1810 1871.5 L 1809 1871.5 L 1809.5 1868 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1668"
          d="M 108.5 1869 L 109 1872.5 L 108 1872.5 L 108.5 1869 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1669"
          d="M 13.5 1871 L 14 1874.5 L 13 1874.5 L 13.5 1871 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1670"
          d="M 1717.5 1875 L 1718 1879.5 L 1717 1879.5 L 1717.5 1875 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1671"
          d="M 1810.5 1876 L 1811 1879.5 L 1810 1879.5 L 1810.5 1876 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1672"
          d="M 107.5 1877 L 108 1880.5 L 107 1880.5 L 107.5 1877 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1673"
          d="M 12.5 1879 L 13 1882.5 L 12 1882.5 L 12.5 1879 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1674"
          d="M 1561.5 1879 L 1560.5 1881 L 1561.5 1879 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1675"
          d="M 264.5 1881 L 265.5 1883 L 264.5 1881 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1676"
          d="M 1718.5 1884 L 1719 1887.5 L 1718 1887.5 L 1718.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1677"
          d="M 1811.5 1884 L 1812 1888.5 L 1811 1888.5 L 1811.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1678"
          d="M 106.5 1886 L 107 1889.5 L 106 1889.5 L 106.5 1886 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1679"
          d="M 267.5 1886 L 268.5 1888 L 267.5 1886 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1680"
          d="M 11.5 1887 L 12 1891.5 L 11 1891.5 L 11.5 1887 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1681"
          d="M 269.5 1889 L 270.5 1891 L 269.5 1889 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1682"
          d="M 271.5 1892 L 272.5 1894 L 271.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1683"
          d="M 1719.5 1892 L 1720 1895.5 L 1719 1895.5 L 1719.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1684"
          d="M 1812.5 1893 L 1813 1896.5 L 1812 1896.5 L 1812.5 1893 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1685"
          d="M 105.5 1894 L 106 1897.5 L 105 1897.5 L 105.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1686"
          d="M 10.5 1896 L 11 1899.5 L 10 1899.5 L 10.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1687"
          d="M 274.5 1896 L 275.5 1898 L 274.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1688"
          d="M 1550.5 1896 L 1549.5 1898 L 1550.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1689"
          d="M 276.5 1899 L 278.5 1902 L 276.5 1899 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1690"
          d="M 1548.5 1899 L 1546.5 1902 L 1548.5 1899 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1691"
          d="M 1720.5 1900 L 1721 1903.5 L 1720 1903.5 L 1720.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1692"
          d="M 1813.5 1901 L 1814 1904.5 L 1813 1904.5 L 1813.5 1901 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1693"
          d="M 104.5 1902 L 105 1905.5 L 104 1905.5 L 104.5 1902 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1694"
          d="M 9.5 1904 L 10 1907.5 L 9 1907.5 L 9.5 1904 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1695"
          d="M 280.5 1904 L 282.5 1907 L 280.5 1904 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1696"
          d="M 1544.5 1904 L 1542.5 1907 L 1544.5 1904 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1697"
          d="M 1721.5 1909 L 1722 1912.5 L 1721 1912.5 L 1721.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1698"
          d="M 285.5 1910 L 296.5 1922 L 285.5 1910 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1699"
          d="M 1539.5 1910 L 1528.5 1922 L 1539.5 1910 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1700"
          d="M 1814.5 1910 L 1815 1913.5 L 1814 1913.5 L 1814.5 1910 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1701"
          d="M 103.5 1911 L 104 1914.5 L 103 1914.5 L 103.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1702"
          d="M 8.5 1912 L 9 1915.5 L 8 1915.5 L 8.5 1912 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1703"
          d="M 1722.5 1917 L 1723 1920.5 L 1722 1920.5 L 1722.5 1917 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1704"
          d="M 1815.5 1918 L 1816 1921.5 L 1815 1921.5 L 1815.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1705"
          d="M 102.5 1919 L 103 1922.5 L 102 1922.5 L 102.5 1919 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1706"
          d="M 7.5 1921 L 8 1924.5 L 7 1924.5 L 7.5 1921 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1707"
          d="M 300.5 1924 L 302.5 1927 L 300.5 1924 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1708"
          d="M 1524.5 1924 L 1522.5 1927 L 1524.5 1924 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1709"
          d="M 1723.5 1925 L 1724 1928.5 L 1723 1928.5 L 1723.5 1925 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1710"
          d="M 1816.5 1926 L 1817 1930.5 L 1816 1930.5 L 1816.5 1926 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1711"
          d="M 101.5 1927 L 102 1930.5 L 101 1930.5 L 101.5 1927 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1712"
          d="M 305.5 1928 L 306.5 1930 L 305.5 1928 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1713"
          d="M 1519.5 1928 L 1518.5 1930 L 1519.5 1928 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1714"
          d="M 6.5 1929 L 7 1932.5 L 6 1932.5 L 6.5 1929 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1715"
          d="M 308.5 1930 L 309.5 1932 L 308.5 1930 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1716"
          d="M 1516.5 1930 L 1515.5 1932 L 1516.5 1930 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1717"
          d="M 1724.5 1933 L 1725 1937.5 L 1724 1937.5 L 1724.5 1933 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1718"
          d="M 314.5 1934 L 315.5 1936 L 314.5 1934 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1719"
          d="M 1510.5 1934 L 1509.5 1936 L 1510.5 1934 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1720"
          d="M 1817.5 1935 L 1818 1938.5 L 1817 1938.5 L 1817.5 1935 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1721"
          d="M 100.5 1936 L 101 1939.5 L 100 1939.5 L 100.5 1936 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1722"
          d="M 5.5 1937 L 6 1940.5 L 5 1940.5 L 5.5 1937 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1723"
          d="M 319.5 1937 L 320.5 1939 L 319.5 1937 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1724"
          d="M 1505.5 1937 L 1504.5 1939 L 1505.5 1937 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1725"
          d="M 1725.5 1942 L 1726 1945.5 L 1725 1945.5 L 1725.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1726"
          d="M 1818.5 1943 L 1819 1946.5 L 1818 1946.5 L 1818.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1727"
          d="M 99.5 1944 L 100 1947.5 L 99 1947.5 L 99.5 1944 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1728"
          d="M 4.5 1946 L 5 1949.5 L 4 1949.5 L 4.5 1946 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1729"
          d="M 1726.5 1950 L 1727 1953.5 L 1726 1953.5 L 1726.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1730"
          d="M 98.5 1952 L 99 1955.5 L 98 1955.5 L 98.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1731"
          d="M 1819.5 1952 L 1820 1955.5 L 1819 1955.5 L 1819.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1732"
          d="M 3.5 1954 L 4 1957.5 L 3 1957.5 L 3.5 1954 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1733"
          d="M 370.5 1955 L 373 1955.5 L 370.5 1956 L 370.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1734"
          d="M 1452.5 1955 L 1455 1955.5 L 1452.5 1956 L 1452.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1735"
          d="M 376.5 1956 L 380 1956.5 L 376.5 1957 L 376.5 1956 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1736"
          d="M 1445.5 1956 L 1449 1956.5 L 1445.5 1957 L 1445.5 1956 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1737"
          d="M 385.5 1957 L 391 1957.5 L 385.5 1958 L 385.5 1957 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1738"
          d="M 1434.5 1957 L 1440 1957.5 L 1434.5 1958 L 1434.5 1957 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1739"
          d="M 405.5 1958 L 1420 1958.5 L 405.5 1959 L 405.5 1958 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1740"
          d="M 1727.5 1958 L 1728 1961.5 L 1727 1961.5 L 1727.5 1958 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1741"
          d="M 97.5 1960 L 98 1964.5 L 97 1964.5 L 97.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1742"
          d="M 1820.5 1960 L 1821 1964.5 L 1820 1964.5 L 1820.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1743"
          d="M 2.5 1962 L 3 1965.5 L 2 1965.5 L 2.5 1962 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1744"
          d="M 1728.5 1967 L 1729 1970.5 L 1728 1970.5 L 1728.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1745"
          d="M 96.5 1969 L 97 1972.5 L 96 1972.5 L 96.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1746"
          d="M 1821.5 1970 L 1822 1979.5 L 1821 1979.5 L 1821.5 1970 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1747"
          d="M 1.5 1971 L 2 1977.5 L 1 1977.5 L 1.5 1971 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1748"
          d="M 1729.5 1975 L 1730 1978.5 L 1729 1978.5 L 1729.5 1975 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1749"
          d="M 95.5 1977 L 96 1997.5 L 95 1997.5 L 95.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1750"
          d="M 1730.5 1985 L 1731 1996.5 L 1730 1996.5 L 1730.5 1985 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1751"
          d="M 1821.5 1994 L 1822 2002.5 L 1821 2002.5 L 1821.5 1994 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1752"
          d="M 1729.5 2002 L 1730 2005.5 L 1729 2005.5 L 1729.5 2002 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1753"
          d="M 96.5 2003 L 97 2006.5 L 96 2006.5 L 96.5 2003 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1754"
          d="M 1.5 2005 L 2 2010.5 L 1 2010.5 L 1.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1755"
          d="M 1728.5 2009 L 1729 2011.5 L 1728 2011.5 L 1728.5 2009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1756"
          d="M 1820.5 2009 L 1821 2012.5 L 1820 2012.5 L 1820.5 2009 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1757"
          d="M 97.5 2010 L 98 2012.5 L 97 2012.5 L 97.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1758"
          d="M 2.5 2016 L 3 2019.5 L 2 2019.5 L 2.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1759"
          d="M 1819.5 2017 L 1820 2019.5 L 1819 2019.5 L 1819.5 2017 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1760"
          d="M 3.5 2023 L 4 2025.5 L 3 2025.5 L 3.5 2023 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1761"
          d="M 1818.5 2023 L 1819 2025.5 L 1818 2025.5 L 1818.5 2023 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1762"
          d="M 1719.5 2036 L 1718.5 2038 L 1719.5 2036 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1763"
          d="M 112.5 2049 L 113.5 2051 L 112.5 2049 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1764"
          d="M 1710.5 2050 L 1708.5 2053 L 1710.5 2050 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1765"
          d="M 114.5 2052 L 116.5 2055 L 114.5 2052 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1766"
          d="M 1706.5 2055 L 1690.5 2072 L 1706.5 2055 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1767"
          d="M 117.5 2056 L 120.5 2060 L 117.5 2056 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1768"
          d="M 129.5 2068 L 133.5 2073 L 129.5 2068 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1769"
          d="M 1687.5 2073 L 1685.5 2076 L 1687.5 2073 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1770"
          d="M 136.5 2074 L 137.5 2076 L 136.5 2074 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1771"
          d="M 139.5 2076 L 140.5 2078 L 139.5 2076 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1772"
          d="M 24.5 2085 L 25.5 2087 L 24.5 2085 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1773"
          d="M 1795.5 2088 L 1794.5 2090 L 1795.5 2088 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1774"
          d="M 27.5 2090 L 28.5 2092 L 27.5 2090 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1775"
          d="M 1792.5 2093 L 1791.5 2095 L 1792.5 2093 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1776"
          d="M 186.5 2096 L 189 2096.5 L 186.5 2097 L 186.5 2096 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1777"
          d="M 1635.5 2096 L 1638 2096.5 L 1635.5 2097 L 1635.5 2096 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1778"
          d="M 193.5 2097 L 197 2097.5 L 193.5 2098 L 193.5 2097 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1779"
          d="M 1628.5 2097 L 1632 2097.5 L 1628.5 2098 L 1628.5 2097 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1780"
          d="M 207.5 2098 L 1618 2098.5 L 207.5 2099 L 207.5 2098 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1781"
          d="M 35.5 2102 L 36.5 2104 L 35.5 2102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1782"
          d="M 1786.5 2102 L 1785.5 2104 L 1786.5 2102 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1783"
          d="M 1784.5 2105 L 1783.5 2107 L 1784.5 2105 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1784"
          d="M 38.5 2106 L 39.5 2108 L 38.5 2106 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1785"
          d="M 1781.5 2109 L 1780.5 2111 L 1781.5 2109 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1786"
          d="M 41.5 2110 L 43.5 2113 L 41.5 2110 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1787"
          d="M 1778.5 2113 L 1775.5 2117 L 1778.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1788"
          d="M 46.5 2116 L 52.5 2123 L 46.5 2116 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1789"
          d="M 1773.5 2119 L 1766.5 2127 L 1773.5 2119 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1790"
          d="M 56.5 2127 L 62.5 2134 L 56.5 2127 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1791"
          d="M 1759.5 2133 L 1752.5 2141 L 1759.5 2133 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1792"
          d="M 67.5 2137 L 72.5 2143 L 67.5 2137 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1793"
          d="M 1749.5 2142 L 1746.5 2146 L 1749.5 2142 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1794"
          d="M 75.5 2144 L 77.5 2147 L 75.5 2144 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1795"
          d="M 1743.5 2147 L 1742.5 2149 L 1743.5 2147 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1796"
          d="M 80.5 2148 L 81.5 2150 L 80.5 2148 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1797"
          d="M 1739.5 2150 L 1738.5 2152 L 1739.5 2150 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1798"
          d="M 84.5 2151 L 85.5 2153 L 84.5 2151 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1799"
          d="M 1735.5 2153 L 1734.5 2155 L 1735.5 2153 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1800"
          d="M 1732.5 2155 L 1731.5 2157 L 1732.5 2155 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1801"
          d="M 1729.5 2157 L 1728.5 2159 L 1729.5 2157 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1802"
          d="M 1726.5 2159 L 1725.5 2161 L 1726.5 2159 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1803"
          d="M 1721.5 2162 L 1720.5 2164 L 1721.5 2162 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1804"
          d="M 1714.5 2166 L 1713.5 2168 L 1714.5 2166 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1805"
          d="M 160.5 2186 L 163 2186.5 L 160.5 2187 L 160.5 2186 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1806"
          d="M 1656.5 2187 L 1659 2187.5 L 1656.5 2188 L 1656.5 2187 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1807"
          d="M 170.5 2188 L 173 2188.5 L 170.5 2189 L 170.5 2188 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1808"
          d="M 1651.5 2188 L 1654 2188.5 L 1651.5 2189 L 1651.5 2188 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1809"
          d="M 176.5 2189 L 180 2189.5 L 176.5 2190 L 176.5 2189 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1810"
          d="M 1645.5 2189 L 1648 2189.5 L 1645.5 2190 L 1645.5 2189 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1811"
          d="M 184.5 2190 L 189 2190.5 L 184.5 2191 L 184.5 2190 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1812"
          d="M 1636.5 2190 L 1641 2190.5 L 1636.5 2191 L 1636.5 2190 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1813"
          d="M 196.5 2191 L 1629 2191.5 L 196.5 2192 L 196.5 2191 Z"
          fill="currentColor"
          fillOpacity="0.6784314"
          stroke="currentColor"
          strokeOpacity="0.6784314"
          strokeWidth="1"/>
        <path
          id="path_1814"
          d="M 674.5 1 L 710.5 1 Q 712.3 3.8 718.5 2 L 737.5 6 L 755.5 12 Q 796.8 28.7 824 59.5 Q 845.8 83.2 859 115.5 L 864 130.5 L 869 153.5 L 870 185.5 Q 866.1 203.1 854.5 213 Q 846.8 219.8 835.5 223 L 816.5 224 L 803.5 220 Q 793.8 214.8 787 206.5 L 779 191.5 L 777 180.5 L 777 165.5 L 771 144.5 Q 762.3 124.7 746.5 112 Q 726.6 93.9 689.5 93 L 666.5 97 L 648.5 105 Q 634.8 113.3 625 125.5 L 614 144.5 L 609 164.5 L 609 255 L 935.5 255 L 936 254.5 L 936 161.5 L 937 160.5 L 937 151.5 L 938 150.5 L 939 139.5 L 949 107.5 Q 964 73.5 989.5 50 Q 1013.7 26.7 1047.5 13 L 1065.5 7 L 1089.5 2 Q 1095.8 3.8 1097.5 1 L 1133.5 1 L 1164.5 7 Q 1185.3 13.2 1202.5 23 Q 1231.2 39.3 1252 63.5 Q 1271.9 86.1 1284 116.5 L 1289 131.5 L 1294 155.5 L 1295 183.5 Q 1291.2 205.7 1275.5 216 Q 1264.1 225.6 1241.5 224 Q 1221 220 1211 205.5 L 1204 192.5 L 1202 183.5 L 1201 163.5 L 1195 145.5 Q 1186.2 127.3 1171.5 115 Q 1160.3 105.3 1145.5 99 L 1127.5 94 L 1112.5 93 L 1111.5 94 L 1101.5 94 L 1091.5 96 L 1079.5 100 Q 1059.1 108.6 1046 124.5 L 1035 142.5 L 1029 164.5 L 1029 442 L 1474.5 442 L 1475.5 443 L 1489.5 444 L 1514.5 450 L 1550.5 465 Q 1586.3 484.7 1612 514.5 Q 1632.5 538 1646 568.5 L 1655 593.5 L 1661 621.5 L 1663 645.5 L 1665 654.5 L 1665 662.5 L 1666 663.5 L 1668 687.5 L 1670 696.5 L 1670 704.5 L 1671 705.5 L 1673 729.5 L 1675 738.5 L 1675 746.5 L 1676 747.5 L 1678 771.5 L 1680 780.5 L 1680 788.5 L 1681 789.5 L 1683 813.5 L 1685 822.5 L 1685 830.5 L 1686 831.5 L 1688 855.5 L 1690 864.5 L 1690 872.5 L 1691 873.5 L 1693 897.5 L 1695 906.5 L 1695 914.5 L 1696 915.5 L 1698 939.5 L 1700 948.5 L 1700 956.5 L 1701 957.5 L 1703 981.5 L 1705 990.5 L 1705 998.5 L 1708 1015.5 L 1709 1031.5 L 1710 1032.5 L 1710 1040.5 L 1711 1041.5 L 1713 1065.5 L 1715 1074.5 L 1715 1082.5 L 1716 1083.5 L 1718 1107.5 L 1721 1124.5 L 1721 1132.5 L 1723 1141.5 L 1723 1149.5 L 1724 1150.5 L 1726 1174.5 L 1728 1183.5 L 1728 1191.5 L 1731 1208.5 L 1733 1233.5 L 1736 1250.5 L 1738 1275.5 L 1741 1292.5 L 1743 1317.5 L 1746 1334.5 L 1748 1359.5 L 1751 1376.5 L 1753 1401.5 L 1756 1418.5 L 1758 1443.5 L 1761 1460.5 L 1763 1485.5 L 1766 1502.5 L 1768 1527.5 L 1771 1544.5 L 1773 1569.5 L 1776 1586.5 L 1778 1611.5 L 1781 1628.5 L 1783 1653.5 L 1786 1670.5 L 1788 1695.5 L 1791 1712.5 L 1793 1737.5 L 1796 1754.5 L 1798 1779.5 L 1801 1796.5 L 1803 1821.5 L 1804 1822.5 L 1806 1846.5 L 1809 1863.5 L 1809 1871.5 L 1811 1880.5 L 1811 1888.5 L 1812 1889.5 L 1814 1913.5 L 1816 1922.5 L 1816 1930.5 L 1819 1947.5 L 1819 1955.5 L 1821 1965.5 L 1821 1979.5 L 1822 1980.5 L 1822 1993.5 L 1821 1994.5 L 1821 2008.5 L 1820 2009.5 L 1818 2028.5 L 1814 2044.5 L 1805 2069.5 Q 1788.4 2106.9 1760.5 2133 Q 1735.6 2157.1 1702.5 2173 L 1672.5 2184 L 1635.5 2191 L 189.5 2191 L 188.5 2190 L 173.5 2189 L 154.5 2185 L 120.5 2173 Q 80.7 2154.3 53 2123.5 Q 28.5 2098.5 14 2063.5 L 8 2045.5 L 3 2022.5 L 2 2005.5 L 1 2004.5 L 1 1978.5 L 2 1977.5 L 2 1966.5 L 3 1965.5 L 5 1941.5 L 8 1924.5 L 8 1916.5 L 9 1915.5 L 9 1908.5 L 12 1891.5 L 12 1883.5 L 15 1866.5 L 15 1858.5 L 18 1841.5 L 18 1833.5 L 21 1816.5 L 21 1808.5 L 24 1791.5 L 24 1783.5 L 25 1782.5 L 27 1758.5 L 30 1741.5 L 30 1733.5 L 33 1716.5 L 33 1708.5 L 34 1707.5 L 34 1700.5 L 37 1683.5 L 37 1675.5 L 40 1658.5 L 40 1650.5 L 43 1633.5 L 43 1625.5 L 46 1608.5 L 46 1600.5 L 49 1583.5 L 49 1575.5 L 50 1574.5 L 52 1550.5 L 55 1533.5 L 55 1525.5 L 58 1508.5 L 58 1500.5 L 59 1499.5 L 59 1492.5 L 62 1475.5 L 62 1467.5 L 65 1450.5 L 65 1442.5 L 68 1425.5 L 68 1417.5 L 71 1400.5 L 71 1392.5 L 74 1375.5 L 74 1367.5 L 77 1350.5 L 77 1342.5 L 78 1341.5 L 80 1317.5 L 83 1300.5 L 83 1292.5 L 84 1291.5 L 84 1284.5 L 87 1267.5 L 87 1259.5 L 90 1242.5 L 90 1234.5 L 93 1217.5 L 93 1209.5 L 96 1192.5 L 96 1184.5 L 99 1167.5 L 99 1159.5 L 102 1142.5 L 102 1134.5 L 103 1133.5 L 105 1109.5 L 108 1092.5 L 108 1084.5 L 109 1083.5 L 109 1076.5 L 112 1059.5 L 112 1051.5 L 115 1034.5 L 115 1026.5 L 118 1009.5 L 118 1001.5 L 121 984.5 L 121 976.5 L 124 959.5 L 124 951.5 L 127 934.5 L 127 926.5 L 130 909.5 L 130 901.5 L 131 900.5 L 133 876.5 L 134 875.5 L 134 868.5 L 137 851.5 L 137 843.5 L 140 826.5 L 140 818.5 L 143 801.5 L 143 793.5 L 146 776.5 L 146 768.5 L 149 751.5 L 149 743.5 L 152 726.5 L 152 718.5 L 155 701.5 L 155 693.5 L 158 676.5 L 158 668.5 L 159 667.5 L 164 620.5 L 172 587.5 Q 179 567 189 549.5 Q 206 519.5 230.5 497 Q 270.4 457.9 335.5 444 L 349.5 443 L 350.5 442 L 516 442 L 516 160.5 L 517 159.5 L 517 151.5 L 522 126.5 Q 527.6 106.6 537 90.5 Q 551 65.5 571.5 47 Q 591.7 28.2 618.5 16 L 643.5 7 L 674.5 1 Z M 609 348 L 609 465 L 936 465 L 936 348 L 609 348 Z M 368 534 L 367 535 L 349 536 L 329 542 Q 312 549 299 560 Q 267 585 257 632 L 252 679 L 251 680 L 251 688 L 248 705 L 248 713 L 245 730 L 245 738 L 242 755 L 242 763 L 239 780 L 239 788 L 236 805 L 236 812 L 235 813 L 235 821 L 232 838 L 232 846 L 229 863 L 229 871 L 226 888 L 226 896 L 223 913 L 223 921 L 220 938 L 220 946 L 217 963 L 217 971 L 214 988 L 214 995 L 213 996 L 211 1020 L 210 1021 L 210 1029 L 207 1046 L 207 1054 L 204 1071 L 204 1079 L 201 1096 L 201 1104 L 198 1121 L 198 1129 L 195 1146 L 195 1154 L 192 1171 L 192 1178 L 191 1179 L 191 1187 L 188 1204 L 186 1228 L 185 1229 L 185 1237 L 182 1254 L 182 1262 L 179 1279 L 179 1287 L 176 1304 L 176 1312 L 173 1329 L 173 1337 L 170 1354 L 170 1362 L 167 1379 L 167 1386 L 166 1387 L 166 1395 L 163 1412 L 161 1436 L 160 1437 L 160 1445 L 157 1462 L 157 1470 L 154 1487 L 154 1495 L 151 1512 L 151 1520 L 148 1537 L 148 1545 L 145 1562 L 145 1569 L 144 1570 L 144 1578 L 141 1595 L 141 1603 L 138 1620 L 136 1644 L 135 1645 L 135 1653 L 132 1670 L 132 1678 L 129 1695 L 129 1703 L 126 1720 L 126 1728 L 123 1745 L 123 1753 L 120 1770 L 120 1777 L 119 1778 L 119 1786 L 116 1803 L 116 1811 L 113 1828 L 111 1852 L 110 1853 L 110 1861 L 107 1878 L 107 1886 L 104 1903 L 104 1911 L 101 1928 L 101 1936 L 98 1953 L 98 1960 L 97 1961 L 96 1977 L 95 1978 L 95 1998 L 99 2021 Q 105 2041 117 2057 Q 134 2078 161 2089 L 187 2097 L 207 2098 L 208 2099 L 1618 2099 L 1619 2098 L 1638 2097 L 1659 2091 Q 1677 2084 1691 2072 Q 1708 2057 1720 2037 L 1728 2016 L 1730 2006 L 1730 1998 L 1731 1997 L 1731 1986 L 1730 1985 L 1729 1968 L 1728 1967 L 1728 1959 L 1725 1942 L 1722 1910 L 1721 1909 L 1721 1901 L 1718 1884 L 1718 1876 L 1715 1859 L 1712 1827 L 1711 1826 L 1711 1818 L 1708 1801 L 1708 1793 L 1705 1776 L 1705 1769 L 1704 1768 L 1704 1760 L 1701 1743 L 1698 1711 L 1697 1710 L 1694 1677 L 1691 1660 L 1691 1653 L 1690 1652 L 1690 1644 L 1687 1627 L 1687 1619 L 1684 1602 L 1681 1570 L 1680 1569 L 1680 1561 L 1677 1544 L 1677 1536 L 1674 1519 L 1674 1512 L 1673 1511 L 1673 1503 L 1670 1486 L 1667 1454 L 1666 1453 L 1663 1420 L 1660 1403 L 1660 1396 L 1659 1395 L 1659 1387 L 1656 1370 L 1656 1362 L 1653 1345 L 1650 1313 L 1649 1312 L 1649 1304 L 1646 1287 L 1646 1279 L 1643 1262 L 1643 1255 L 1642 1254 L 1642 1246 L 1639 1229 L 1636 1197 L 1635 1196 L 1632 1163 L 1629 1146 L 1629 1139 L 1628 1138 L 1628 1130 L 1625 1113 L 1625 1105 L 1622 1088 L 1619 1056 L 1618 1055 L 1618 1047 L 1615 1030 L 1615 1022 L 1612 1005 L 1612 998 L 1611 997 L 1611 989 L 1608 972 L 1605 940 L 1604 939 L 1601 906 L 1598 889 L 1598 882 L 1597 881 L 1597 873 L 1594 856 L 1594 848 L 1591 831 L 1588 799 L 1587 798 L 1587 790 L 1584 773 L 1584 765 L 1581 748 L 1581 741 L 1580 740 L 1580 732 L 1577 715 L 1574 683 L 1573 682 L 1573 674 L 1570 657 L 1569 641 L 1566 625 L 1561 610 Q 1553 591 1541 577 Q 1516 545 1470 535 L 1029 535 L 1029 698 L 1312 698 L 1313 699 L 1325 699 L 1351 704 L 1371 711 Q 1394 721 1412 736 Q 1431 752 1444 775 L 1455 798 L 1463 830 L 1464 846 L 1467 863 L 1467 870 L 1468 871 L 1468 878 L 1469 879 L 1469 886 L 1470 887 L 1470 895 L 1473 912 L 1473 919 L 1474 920 L 1474 927 L 1475 928 L 1475 935 L 1476 936 L 1476 943 L 1477 944 L 1477 952 L 1480 969 L 1480 976 L 1481 977 L 1481 984 L 1482 985 L 1482 992 L 1483 993 L 1483 1001 L 1486 1018 L 1486 1025 L 1487 1026 L 1487 1033 L 1488 1034 L 1488 1041 L 1489 1042 L 1489 1050 L 1492 1067 L 1492 1074 L 1493 1075 L 1493 1082 L 1494 1083 L 1494 1090 L 1495 1091 L 1495 1099 L 1498 1116 L 1498 1123 L 1499 1124 L 1499 1131 L 1500 1132 L 1500 1139 L 1501 1140 L 1501 1148 L 1504 1165 L 1504 1172 L 1505 1173 L 1505 1180 L 1506 1181 L 1506 1188 L 1507 1189 L 1507 1196 L 1508 1197 L 1508 1205 L 1511 1222 L 1511 1229 L 1512 1230 L 1512 1237 L 1513 1238 L 1513 1245 L 1514 1246 L 1514 1254 L 1517 1271 L 1517 1278 L 1518 1279 L 1518 1286 L 1519 1287 L 1519 1294 L 1520 1295 L 1520 1303 L 1523 1320 L 1523 1327 L 1524 1328 L 1524 1335 L 1525 1336 L 1525 1343 L 1526 1344 L 1526 1352 L 1529 1369 L 1529 1376 L 1530 1377 L 1530 1384 L 1531 1385 L 1531 1392 L 1532 1393 L 1532 1400 L 1533 1401 L 1533 1409 L 1536 1426 L 1536 1433 L 1537 1434 L 1537 1441 L 1538 1442 L 1538 1449 L 1539 1450 L 1539 1458 L 1542 1475 L 1542 1482 L 1543 1483 L 1543 1490 L 1544 1491 L 1544 1498 L 1545 1499 L 1545 1507 L 1548 1524 L 1548 1531 L 1549 1532 L 1549 1539 L 1550 1540 L 1550 1547 L 1551 1548 L 1551 1556 L 1554 1573 L 1554 1580 L 1555 1581 L 1555 1588 L 1556 1589 L 1556 1596 L 1557 1597 L 1557 1604 L 1558 1605 L 1558 1613 L 1561 1630 L 1561 1637 L 1562 1638 L 1562 1645 L 1563 1646 L 1563 1653 L 1564 1654 L 1564 1662 L 1567 1679 L 1567 1686 L 1568 1687 L 1568 1694 L 1569 1695 L 1569 1702 L 1570 1703 L 1570 1711 L 1573 1728 L 1573 1735 L 1574 1736 L 1574 1743 L 1575 1744 L 1575 1751 L 1576 1752 L 1576 1760 L 1579 1777 L 1579 1784 L 1580 1785 L 1580 1799 L 1581 1800 L 1580 1822 L 1579 1823 L 1578 1835 L 1570 1862 Q 1559 1888 1542 1908 Q 1523 1931 1494 1944 L 1463 1954 L 1446 1956 L 1445 1957 L 1435 1957 L 1434 1958 L 392 1958 L 391 1957 L 381 1957 L 380 1956 L 363 1954 L 342 1948 Q 317 1939 300 1924 Q 272 1900 256 1865 L 248 1841 L 245 1824 L 245 1810 L 244 1809 L 245 1787 L 248 1770 L 248 1763 L 249 1762 L 249 1755 L 250 1754 L 250 1746 L 253 1729 L 253 1722 L 254 1721 L 254 1713 L 257 1696 L 257 1689 L 258 1688 L 258 1681 L 259 1680 L 259 1672 L 262 1655 L 262 1648 L 263 1647 L 263 1639 L 266 1622 L 266 1615 L 267 1614 L 267 1607 L 268 1606 L 268 1598 L 271 1581 L 271 1574 L 272 1573 L 272 1565 L 275 1548 L 275 1541 L 276 1540 L 276 1533 L 277 1532 L 277 1524 L 280 1507 L 280 1500 L 281 1499 L 281 1491 L 284 1474 L 284 1467 L 285 1466 L 285 1459 L 286 1458 L 286 1450 L 289 1433 L 289 1426 L 290 1425 L 290 1417 L 293 1400 L 293 1393 L 294 1392 L 294 1385 L 295 1384 L 295 1376 L 298 1359 L 298 1352 L 299 1351 L 299 1343 L 302 1326 L 302 1319 L 303 1318 L 303 1311 L 304 1310 L 304 1302 L 307 1285 L 307 1278 L 308 1277 L 308 1270 L 309 1269 L 309 1261 L 312 1244 L 312 1237 L 313 1236 L 313 1228 L 316 1211 L 316 1204 L 317 1203 L 317 1196 L 318 1195 L 318 1187 L 321 1170 L 321 1163 L 322 1162 L 322 1154 L 325 1137 L 325 1130 L 326 1129 L 326 1122 L 327 1121 L 327 1113 L 330 1096 L 330 1089 L 331 1088 L 331 1080 L 334 1063 L 334 1056 L 335 1055 L 335 1048 L 336 1047 L 336 1039 L 339 1022 L 339 1015 L 340 1014 L 340 1006 L 343 989 L 343 982 L 344 981 L 344 974 L 345 973 L 345 965 L 348 948 L 348 941 L 349 940 L 349 932 L 352 915 L 352 908 L 353 907 L 353 900 L 354 899 L 354 891 L 357 874 L 357 867 L 358 866 L 358 858 L 361 841 L 361 834 L 362 833 L 362 826 L 366 806 L 374 783 Q 384 759 400 742 Q 418 720 444 706 Q 459 697 478 692 L 504 687 L 516 687 L 516 687 L 516 535 L 497 535 L 496 534 L 368 534 Z M 609 558 L 609 698 L 936 698 L 936 558 L 609 558 Z M 510 780 Q 492 784 481 793 Q 470 801 464 812 L 456 831 L 454 842 L 453 858 L 450 875 L 450 882 L 449 883 L 449 890 L 448 891 L 448 899 L 445 916 L 445 923 L 444 924 L 444 931 L 443 932 L 443 940 L 440 957 L 440 964 L 439 965 L 439 972 L 438 973 L 438 981 L 435 998 L 435 1005 L 434 1006 L 434 1013 L 433 1014 L 433 1022 L 432 1023 L 430 1046 L 429 1047 L 429 1054 L 428 1055 L 428 1063 L 425 1080 L 425 1087 L 424 1088 L 424 1095 L 423 1096 L 423 1104 L 420 1121 L 420 1128 L 419 1129 L 419 1136 L 418 1137 L 418 1145 L 415 1162 L 415 1169 L 414 1170 L 414 1177 L 413 1178 L 413 1186 L 410 1203 L 410 1210 L 409 1211 L 409 1218 L 408 1219 L 408 1227 L 405 1244 L 405 1251 L 404 1252 L 404 1259 L 403 1260 L 403 1268 L 400 1285 L 400 1292 L 399 1293 L 399 1300 L 398 1301 L 398 1309 L 395 1326 L 395 1333 L 394 1334 L 394 1341 L 393 1342 L 393 1350 L 390 1367 L 390 1374 L 389 1375 L 389 1382 L 388 1383 L 388 1391 L 385 1408 L 385 1415 L 384 1416 L 384 1423 L 383 1424 L 383 1432 L 380 1449 L 380 1456 L 379 1457 L 379 1464 L 378 1465 L 378 1473 L 375 1490 L 375 1497 L 374 1498 L 374 1505 L 373 1506 L 373 1514 L 370 1531 L 370 1538 L 369 1539 L 369 1546 L 368 1547 L 368 1555 L 365 1572 L 365 1579 L 364 1580 L 364 1587 L 363 1588 L 363 1596 L 360 1613 L 360 1620 L 359 1621 L 359 1628 L 358 1629 L 358 1637 L 355 1654 L 355 1661 L 354 1662 L 354 1669 L 353 1670 L 353 1678 L 350 1695 L 350 1702 L 349 1703 L 349 1710 L 348 1711 L 348 1719 L 345 1736 L 345 1743 L 344 1744 L 344 1751 L 343 1752 L 343 1760 L 340 1777 L 340 1784 L 339 1785 L 339 1792 L 338 1793 L 338 1815 L 339 1820 Q 343 1834 352 1844 L 369 1858 L 382 1863 L 393 1865 L 1434 1865 L 1451 1862 L 1468 1854 Q 1477 1846 1483 1835 L 1488 1823 L 1489 1812 L 1490 1811 L 1484 1757 L 1483 1756 L 1483 1749 L 1482 1748 L 1482 1741 L 1481 1740 L 1480 1724 L 1479 1723 L 1479 1716 L 1478 1715 L 1478 1708 L 1477 1707 L 1477 1700 L 1476 1699 L 1476 1691 L 1473 1674 L 1473 1667 L 1472 1666 L 1472 1659 L 1471 1658 L 1471 1650 L 1468 1633 L 1468 1626 L 1467 1625 L 1467 1618 L 1466 1617 L 1466 1609 L 1463 1592 L 1463 1585 L 1462 1584 L 1462 1577 L 1461 1576 L 1461 1568 L 1458 1551 L 1458 1544 L 1457 1543 L 1457 1536 L 1456 1535 L 1456 1527 L 1453 1510 L 1453 1503 L 1452 1502 L 1452 1495 L 1451 1494 L 1451 1486 L 1448 1469 L 1448 1462 L 1447 1461 L 1447 1454 L 1446 1453 L 1446 1445 L 1443 1428 L 1443 1421 L 1442 1420 L 1442 1413 L 1441 1412 L 1441 1404 L 1438 1387 L 1438 1380 L 1437 1379 L 1437 1372 L 1436 1371 L 1436 1363 L 1433 1346 L 1433 1339 L 1432 1338 L 1432 1331 L 1431 1330 L 1431 1322 L 1428 1305 L 1428 1298 L 1427 1297 L 1427 1290 L 1426 1289 L 1426 1281 L 1423 1264 L 1423 1257 L 1422 1256 L 1422 1249 L 1421 1248 L 1421 1240 L 1418 1223 L 1418 1216 L 1417 1215 L 1417 1208 L 1416 1207 L 1416 1199 L 1413 1182 L 1413 1175 L 1412 1174 L 1412 1167 L 1411 1166 L 1411 1158 L 1408 1141 L 1408 1134 L 1407 1133 L 1407 1126 L 1406 1125 L 1406 1117 L 1403 1100 L 1403 1093 L 1402 1092 L 1402 1085 L 1401 1084 L 1401 1076 L 1398 1059 L 1398 1052 L 1397 1051 L 1397 1044 L 1396 1043 L 1396 1035 L 1393 1018 L 1393 1011 L 1392 1010 L 1392 1003 L 1391 1002 L 1391 994 L 1388 977 L 1388 970 L 1387 969 L 1387 962 L 1386 961 L 1386 953 L 1383 936 L 1383 929 L 1382 928 L 1382 921 L 1381 920 L 1381 912 L 1378 895 L 1378 888 L 1377 887 L 1377 880 L 1376 879 L 1373 847 L 1368 829 L 1360 816 Q 1352 806 1342 800 L 1331 795 L 1312 791 L 1029 791 L 1029 938 L 1027 947 L 1020 960 Q 1009 974 989 978 L 972 977 L 955 969 Q 940 958 936 938 L 936 791 L 609 791 L 609 938 Q 607 952 599 961 Q 589 974 569 978 L 552 977 L 535 969 Q 520 959 516 938 L 516 781 Q 516 779 510 780 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1815"
          d="M 619.5 1009 L 645.5 1009 L 676.5 1015 Q 693.6 1020.4 707.5 1029 L 745.5 1054 L 755.5 1057 L 776.5 1058 L 794.5 1054 L 805.5 1048 L 833.5 1028 Q 847 1020 863.5 1015 L 894.5 1009 L 929.5 1009 L 930.5 1010 L 938.5 1010 L 949.5 1012 L 974.5 1020 L 995.5 1031 L 1019.5 1048 L 1030.5 1054 L 1040.5 1057 L 1061.5 1058 L 1062.5 1057 L 1073.5 1056 L 1083.5 1052 L 1117.5 1029 L 1142.5 1017 L 1171.5 1010 Q 1177.8 1011.7 1179.5 1009 L 1205.5 1009 Q 1225.2 1013.3 1235 1027.5 Q 1244.1 1038.4 1244 1058.5 Q 1241.5 1060 1243 1065.5 L 1239 1076.5 L 1224.5 1093 Q 1217.2 1098.7 1206.5 1101 L 1184.5 1102 L 1173.5 1105 L 1131.5 1132 L 1112.5 1141 L 1097.5 1146 L 1082.5 1149 L 1050.5 1151 L 1049.5 1150 L 1034.5 1150 L 1033.5 1149 L 1021.5 1148 L 999.5 1142 L 976.5 1131 L 947.5 1111 L 930.5 1103 L 925.5 1102 L 899.5 1102 L 882.5 1108 L 848.5 1131 L 825.5 1142 L 797.5 1149 L 765.5 1151 L 764.5 1150 L 750.5 1150 L 749.5 1149 L 736.5 1148 L 712.5 1141 L 693.5 1132 L 651.5 1105 L 640.5 1102 L 626.5 1102 L 611.5 1099 Q 598 1093.5 590 1082.5 Q 584.3 1075.7 582 1065.5 L 581 1051.5 L 583 1041.5 L 588 1030.5 L 599.5 1018 Q 607.4 1011.4 619.5 1009 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1816"
          d="M 624.5 1256 L 653.5 1257 L 677.5 1262 Q 694 1267 707.5 1275 L 736.5 1295 L 749.5 1302 L 762.5 1305 L 782.5 1305 L 792.5 1303 L 803.5 1298 L 832.5 1278 L 858.5 1265 L 879.5 1259 L 890.5 1258 L 891.5 1257 L 927.5 1256 L 928.5 1257 L 938.5 1257 L 939.5 1258 L 950.5 1259 L 978.5 1268 L 995.5 1277 L 1024.5 1297 L 1034.5 1302 L 1046.5 1305 L 1067.5 1305 L 1077.5 1303 L 1086.5 1299 L 1120.5 1276 L 1143.5 1265 L 1169.5 1258 L 1185.5 1257 L 1186.5 1256 L 1205.5 1256 Q 1226.9 1259.6 1237 1274.5 L 1244 1287.5 L 1246 1296.5 L 1246 1308.5 Q 1242.4 1329.9 1227.5 1340 Q 1220.7 1345.7 1210.5 1348 L 1205.5 1349 L 1189.5 1349 L 1176.5 1352 L 1134.5 1379 Q 1121 1387 1104.5 1392 L 1080.5 1397 L 1044.5 1398 L 1043.5 1397 L 1034.5 1397 L 1017.5 1394 L 993.5 1386 L 976.5 1377 L 947.5 1357 L 937.5 1352 L 925.5 1349 L 904.5 1349 L 894.5 1351 L 885.5 1355 L 851.5 1378 L 828.5 1389 L 812.5 1394 L 795.5 1397 L 759.5 1398 L 758.5 1397 L 749.5 1397 L 732.5 1394 L 713.5 1388 L 688.5 1375 L 655.5 1353 L 640.5 1349 L 624.5 1349 L 615.5 1347 Q 603.5 1343 596 1334.5 Q 588.8 1326.7 585 1315.5 L 584 1310.5 L 584 1294.5 Q 587.7 1277.7 598.5 1268 L 612.5 1259 L 624.5 1256 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1817"
          d="M 622.5 1506 L 646.5 1506 L 678.5 1512 L 704.5 1523 L 738.5 1546 L 750.5 1552 L 765.5 1555 L 779.5 1555 L 794.5 1552 L 804.5 1547 L 840.5 1523 L 866.5 1512 L 897.5 1506 L 931.5 1506 L 959.5 1511 L 983.5 1520 L 1032.5 1551 L 1049.5 1555 L 1064.5 1555 L 1065.5 1554 L 1076.5 1553 L 1089.5 1547 Q 1112.9 1527.9 1142.5 1515 L 1154.5 1511 L 1174.5 1507 Q 1180.8 1508.8 1182.5 1506 L 1207.5 1506 L 1223.5 1512 L 1233 1519 L 1243 1534.5 L 1246 1545.5 L 1246 1558.5 Q 1242.2 1578.7 1228.5 1589 L 1213.5 1597 L 1202.5 1599 L 1186.5 1599 L 1173.5 1603 L 1128.5 1632 L 1103.5 1642 L 1077.5 1647 L 1050.5 1648 L 1049.5 1647 L 1036.5 1647 L 1035.5 1646 L 1018.5 1644 L 996.5 1637 Q 968.9 1624.1 946.5 1606 L 932.5 1600 L 927.5 1599 L 902.5 1599 Q 890.3 1601.3 881.5 1607 Q 859 1625.5 830.5 1638 L 800.5 1646 L 780.5 1647 L 779.5 1648 L 765.5 1648 L 764.5 1647 L 751.5 1647 L 750.5 1646 L 738.5 1645 L 714.5 1638 L 697.5 1630 L 666.5 1609 L 653.5 1602 L 642.5 1599 L 627.5 1599 L 613.5 1596 Q 600.6 1590.9 593 1580.5 Q 586.4 1572.6 584 1560.5 L 584 1543.5 Q 587.9 1525.4 600.5 1516 Q 608.9 1508.4 622.5 1506 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'PoolFifth')

export default icon
